/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Delegate_$type, fromEnum, runOn, markType, typeGetValue, INotifyPropertyChanged_$type, PropertyChangedEventArgs, enumGetBox, EventArgs, delegateCombine, typeCast, fromEn } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { ScaleTransform } from "igniteui-react-core";
import { NativeUI } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
import { KeyFrameAnimationFactory } from "igniteui-react-core";
import { AnimationKeyFrameEffect } from "igniteui-react-core";
import { AnimationKeyFrameEffectTiming } from "igniteui-react-core";
import { stringReplace, stringIsNullOrEmpty } from "igniteui-react-core";
import { TransformGroup } from "igniteui-react-core";
import { TranslateTransform } from "igniteui-react-core";
import { SuffixShiftType_$type } from "./SuffixShiftType";
import { PrefixShiftType_$type } from "./PrefixShiftType";
import { LabelShiftType_$type } from "./LabelShiftType";
import { KeyEventArgs } from "igniteui-react-core";
import { InputShiftType_$type } from "./InputShiftType";
import { InputGroupDisplayType_$type } from "./InputGroupDisplayType";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { CornerRadius } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { ThemeResolver } from "./ThemeResolver";
import { ObservableCollection$1 } from "igniteui-react-core";
import { AnimationKeyFrameProperty } from "igniteui-react-core";
import { BrushUtil } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
import { MaskParsingService } from "./MaskParsingService";
import { InputChangeEventArgs } from "./InputChangeEventArgs";
import { MaskOptions } from "./MaskOptions";
/**
 * @hidden
 */
var InputGroupView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputGroupView, _super);
    function InputGroupView() {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.l = null;
        _this.e = null;
        _this.i = new List$1(Delegate_$type, 0);
        _this.y = null;
        _this.f = true;
        _this.n = null;
        _this.o = null;
        _this.p = null;
        _this.s = null;
        _this.r = null;
        _this.q = null;
        _this.m = null;
        return _this;
    }
    InputGroupView.prototype.ag = function () {
    };
    InputGroupView.prototype.g = function () {
        return true;
    };
    Object.defineProperty(InputGroupView.prototype, "v", {
        get: function () {
            return this.n;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "ao", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "h", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    InputGroupView.prototype.ad = function (a) {
        var e_1, _a;
        var _this = this;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.i)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.i.clear();
        }
        this.l = a;
        a.rootWrapper.setStyleProperty("position", "relative");
        a.rootWrapper.setStyleProperty("box-sizing", "border-box");
        a.rootWrapper.setStyleProperty("border-width", "0px");
        a.rootWrapper.setStyleProperty("border-style", "solid");
        var c = this.u;
        this.i.add(c.listen("focusin", runOn(this, this.af)));
        this.i.add(c.listen("focusout", runOn(this, this.ai)));
        var d = this.l.createElement("div");
        d.setStyleProperty("position", "absolute");
        d.setStyleProperty("width", "100%");
        d.setStyleProperty("height", "100%");
        d.setStyleProperty("border-style", "solid");
        d.setStyleProperty("box-sizing", "border-box");
        d.setStyleProperty("left", "0px");
        d.setStyleProperty("top", "0px");
        this.l.append(d);
        this.m = d;
        var e = this.l.createElement("div");
        e.addClass("ig-input-content");
        e.setStyleProperty("position", "relative");
        e.setStyleProperty("display", "flex");
        e.setStyleProperty("flex-direction", "row");
        e.setStyleProperty("flex-wrap", "no-wrap");
        e.setStyleProperty("flex-flow", "row nowrap");
        e.setStyleProperty("flex-grow", "1");
        e.setStyleProperty("align-items", "center");
        e.setStyleProperty("padding-top", "1.125rem");
        this.p = e;
        this.i.add(e.listen("click", runOn(this, this.z)));
        this.l.append(e);
        this.l.getPortal(e, "ChildContent", function (f) {
            var comp_ = f.componentRef;
            _this.s = comp_;
            _this.p.setStyleProperty("flex-direction", "row");
        }, true);
        var f = this.l.createElement("div");
        f.setStyleProperty("position", "absolute");
        f.setStyleProperty("width", "100%");
        f.setStyleProperty("background-color", "rgba(0, 0, 0, 0.54)");
        f.setStyleProperty("height", "1px");
        f.setStyleProperty("pointer-events", "none");
        f.setStyleProperty("left", "0px");
        f.setStyleProperty("bottom", "1px");
        f.setStyleProperty("overflow", "visible");
        var g = this.l.createElement("span");
        g.setStyleProperty("width", "100%");
        g.setStyleProperty("height", "2px");
        g.setStyleProperty("display", "block");
        g.setStyleProperty("pointer-events", "none");
        NativeUI.z(g, ((function () {
            var $ret = new ScaleTransform();
            $ret.l = 0.5;
            $ret.m = 1;
            return $ret;
        })()));
        g.setStyleProperty("opacity", "0");
        this.r = g;
        f.append(this.r);
        this.q = f;
        this.l.append(f);
        this.d.l6();
    };
    Object.defineProperty(InputGroupView.prototype, "u", {
        get: function () {
            return this.l.rootWrapper;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "t", {
        get: function () {
            return this.m;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "w", {
        get: function () {
            return this.q;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "x", {
        get: function () {
            return this.r;
        },
        enumerable: true,
        configurable: true
    });
    InputGroupView.prototype.am = function (a) {
        if (this.y != a) {
            this.y = a;
            if (this.o != null) {
                this.o.setAttribute("d", this.y);
            }
        }
    };
    InputGroupView.prototype.al = function () {
        switch (this.d.g) {
            case 1:
                this.p.setStyleProperty("padding-top", "1.125rem");
                break;
            case 2:
                this.p.setStyleProperty("padding-top", ".94737rem");
                break;
            case 3:
                this.p.setStyleProperty("padding-top", ".81818rem");
                break;
        }
    };
    InputGroupView.prototype.z = function (a) {
    };
    InputGroupView.prototype.ah = function () {
        if (this.g()) {
        }
    };
    InputGroupView.prototype.j = function () {
        var a = this.l.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    InputGroupView.prototype.ac = function () {
        this.f = true;
    };
    InputGroupView.prototype.ae = function () {
        var e_2, _a;
        this.f = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.i)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        this.i.clear();
    };
    InputGroupView.prototype.an = function (a) {
        if (a != null) {
            this.l.rootWrapper.setStyleProperty("font", a.fontString);
        }
    };
    InputGroupView.prototype.k = function (a) {
        return a.view.h();
    };
    InputGroupView.prototype.ab = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.l;
        }
    };
    InputGroupView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.t, 0, null, a);
    };
    InputGroupView.prototype.c = function (a) {
        return new AnimationKeyFrameEffect(0, this.w, 0, null, a);
    };
    InputGroupView.prototype.b = function (a) {
        return new AnimationKeyFrameEffect(0, this.r, 0, null, a);
    };
    InputGroupView.prototype.ak = function (a) {
    };
    InputGroupView.prototype.aa = function (a) {
        this.p.append(a);
    };
    InputGroupView.prototype.aj = function (a) {
        this.p.removeChild(a);
    };
    InputGroupView.prototype.af = function (a) {
        this.d.l2();
    };
    InputGroupView.prototype.ai = function (a) {
        this.d.l4();
    };
    InputGroupView.$t = markType(InputGroupView, 'InputGroupView');
    return InputGroupView;
}(Base));
export { InputGroupView };
/**
 * @hidden
 */
var SuffixView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SuffixView, _super);
    function SuffixView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.g = null;
        _this.b = null;
        _this.e = new List$1(Delegate_$type, 0);
        _this.c = true;
        _this.h = null;
        return _this;
    }
    SuffixView.prototype.o = function () {
    };
    SuffixView.prototype.d = function () {
        return true;
    };
    Object.defineProperty(SuffixView.prototype, "r", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    SuffixView.prototype.m = function (a) {
        var e_3, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_3_1) {
                e_3 = { error: e_3_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_3)
                        throw e_3.error;
                }
            }
            this.e.clear();
        }
        this.g = a;
        this.g.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.g.createElement("div");
        c.addClass("ig-suffix-content");
        this.g.append(c);
        c.setStyleProperty("cursor", "pointer");
        this.h = c;
        this.g.getPortal(c, "ChildContent", function (d) {
        }, true);
        this.a.aj();
    };
    SuffixView.prototype.q = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.a.j == 2 ? (_this.f() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.z(this.g.rootWrapper, a);
        this.g.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    SuffixView.prototype.f = function () {
        var a = this.g.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    SuffixView.prototype.p = function () {
        if (this.d()) {
        }
    };
    SuffixView.prototype.i = function (a) {
        this.a.ag();
    };
    SuffixView.prototype.j = function (a) {
        this.a.ah();
    };
    SuffixView.prototype.l = function () {
        this.c = true;
        this.e.add(this.g.rootWrapper.listen("mouseenter", runOn(this, this.i)));
        this.e.add(this.g.rootWrapper.listen("mouseleave", runOn(this, this.j)));
    };
    SuffixView.prototype.n = function () {
        var e_4, _a;
        this.c = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_4_1) {
            e_4 = { error: e_4_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_4)
                    throw e_4.error;
            }
        }
        this.e.clear();
    };
    SuffixView.prototype.k = function (a) {
        this.h.append(a);
    };
    SuffixView.$t = markType(SuffixView, 'SuffixView');
    return SuffixView;
}(Base));
export { SuffixView };
/**
 * @hidden
 */
var PrefixView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PrefixView, _super);
    function PrefixView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.g = null;
        _this.b = null;
        _this.e = new List$1(Delegate_$type, 0);
        _this.c = true;
        _this.h = null;
        return _this;
    }
    PrefixView.prototype.o = function () {
    };
    PrefixView.prototype.d = function () {
        return true;
    };
    Object.defineProperty(PrefixView.prototype, "r", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    PrefixView.prototype.m = function (a) {
        var e_5, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_5_1) {
                e_5 = { error: e_5_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_5)
                        throw e_5.error;
                }
            }
            this.e.clear();
        }
        this.g = a;
        this.g.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.g.createElement("div");
        c.addClass("ig-prefix-content");
        this.g.append(c);
        c.setStyleProperty("cursor", "pointer");
        this.h = c;
        this.g.getPortal(c, "ChildContent", function (d) {
        }, true);
        this.a.aj();
    };
    PrefixView.prototype.q = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.a.j == 2 ? (_this.f() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.z(this.g.rootWrapper, a);
        this.g.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    PrefixView.prototype.f = function () {
        var a = this.g.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    PrefixView.prototype.p = function () {
        if (this.d()) {
        }
    };
    PrefixView.prototype.i = function (a) {
        this.a.ag();
    };
    PrefixView.prototype.j = function (a) {
        this.a.ah();
    };
    PrefixView.prototype.l = function () {
        this.c = true;
        this.e.add(this.g.rootWrapper.listen("mouseenter", runOn(this, this.i)));
        this.e.add(this.g.rootWrapper.listen("mouseleave", runOn(this, this.j)));
    };
    PrefixView.prototype.n = function () {
        var e_6, _a;
        this.c = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_6_1) {
            e_6 = { error: e_6_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_6)
                    throw e_6.error;
            }
        }
        this.e.clear();
    };
    PrefixView.prototype.k = function (a) {
        this.h.append(a);
    };
    PrefixView.$t = markType(PrefixView, 'PrefixView');
    return PrefixView;
}(Base));
export { PrefixView };
/**
 * @hidden
 */
var LabelView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(LabelView, _super);
    function LabelView() {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.i = null;
        _this.c = null;
        _this.g = new List$1(Delegate_$type, 0);
        _this.m = null;
        _this.d = true;
        _this.j = null;
        _this.k = null;
        return _this;
    }
    LabelView.prototype.y = function () {
    };
    LabelView.prototype.e = function () {
        return true;
    };
    Object.defineProperty(LabelView.prototype, "l", {
        get: function () {
            return this.j;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelView.prototype, "ag", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelView.prototype, "f", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    LabelView.prototype.q = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.i;
        }
    };
    LabelView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.i.rootWrapper, 0, null, a);
    };
    LabelView.prototype.t = function (a) {
        var e_7, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.g)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_7_1) {
                e_7 = { error: e_7_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_7)
                        throw e_7.error;
                }
            }
            this.g.clear();
        }
        this.i = a;
        this.i.rootWrapper.setStyleProperty("display", "inline-block");
        this.i.rootWrapper.setStyleProperty("position", "relative");
        var c = this.i.createElement("label");
        c.setStyleProperty("position", "relative");
        c.setStyleProperty("display", "inline-block");
        c.setStyleProperty("white-space", "nowrap");
        c.setStyleProperty("text-overflow", "ellipsis");
        c.setStyleProperty("line-height", "1");
        c.setStyleProperty("overflow", "hidden");
        c.setStyleProperty("height", "1.125rem");
        c.setStyleProperty("backface-visibility", "hidden");
        NativeUI.n(this.i.rootWrapper, this.b.cq);
        c.setStyleProperty("outline-style", "none");
        c.setStyleProperty("box-shadow", "none");
        c.setStyleProperty("font-family", "'Segoe UI', Verdana");
        c.setStyleProperty("font-size", "1rem");
        this.j = c;
        this.i.append(this.j);
        this.b.b9();
    };
    LabelView.prototype.ac = function () {
        var _this = this;
        this.b.bc = "block";
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.b.r == 0 ? (_this.h() * 0.5) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.z(this.i.rootWrapper, a);
        this.j.setStyleProperty("height", "1.125rem");
        this.i.rootWrapper.setStyleProperty("position", "absolute");
        this.i.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    LabelView.prototype.ad = function () {
        switch (this.b.o) {
            case 1:
                this.i.rootWrapper.setStyleProperty("margin-top", "0px");
                break;
            case 2:
                this.i.rootWrapper.setStyleProperty("margin-top", "-.125rem");
                break;
            case 3:
                this.i.rootWrapper.setStyleProperty("margin-top", "-.25rem");
                break;
        }
    };
    LabelView.prototype.ab = function () {
        this.j.setText(this.b.text != null ? this.b.text : "");
    };
    LabelView.prototype.ae = function (a) {
        if (this.m != a) {
            this.m = a;
            if (this.k != null) {
                this.k.setAttribute("d", this.m);
            }
        }
    };
    LabelView.prototype.v = function () {
        if (this.i != null) {
            this.i.rootWrapper.setStyleProperty("display", this.b.bc);
            this.j.setStyleProperty("display", this.b.bc);
            var ext_ = this.i.getExternal(this.b, null, null);
            if (ext_ && ext_._onDisplayChanged) {
                ext_._onDisplayChanged();
            }
            ;
        }
    };
    LabelView.prototype.r = function () {
        if (this.i != null) {
            this.i.rootWrapper.setStyleProperty("align-items", this.b.a6);
            this.j.setStyleProperty("align-items", this.b.a6);
            var ext_ = this.i.getExternal(this.b, null, null);
            if (ext_ && ext_._onAlignItemsChanged) {
                ext_._onAlignItemsChanged();
            }
            ;
        }
    };
    LabelView.prototype.w = function () {
        if (this.i != null) {
            this.i.rootWrapper.setStyleProperty("flex-direction", this.b.be);
            this.j.setStyleProperty("flex-direction", this.b.be);
            var ext_ = this.i.getExternal(this.b, null, null);
            if (ext_ && ext_._onFlexDirectionChanged) {
                ext_._onFlexDirectionChanged();
            }
            ;
        }
    };
    LabelView.prototype.x = function () {
        if (this.i != null) {
            this.i.rootWrapper.setStyleProperty("flex-grow", this.b.bg);
            this.j.setStyleProperty("flex-grow", this.b.bg);
            var ext_ = this.i.getExternal(this.b, null, null);
            if (ext_ && ext_._onFlexGrowChanged) {
                ext_._onFlexGrowChanged();
            }
            ;
        }
    };
    LabelView.prototype.n = function (a) {
    };
    LabelView.prototype.z = function () {
        if (this.e()) {
        }
    };
    LabelView.prototype.h = function () {
        var a = this.i.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    LabelView.prototype.o = function (a) {
        this.b.b6();
    };
    LabelView.prototype.p = function (a) {
        this.b.b7();
    };
    LabelView.prototype.s = function () {
        this.d = true;
        this.g.add(this.i.rootWrapper.listen("mouseenter", runOn(this, this.o)));
        this.g.add(this.i.rootWrapper.listen("mouseleave", runOn(this, this.p)));
    };
    LabelView.prototype.u = function () {
        var e_8, _a;
        this.d = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.g)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_8_1) {
            e_8 = { error: e_8_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_8)
                    throw e_8.error;
            }
        }
        this.g.clear();
    };
    LabelView.prototype.af = function (a) {
        if (a != null) {
            this.j.setStyleProperty("font", a.fontString);
        }
    };
    LabelView.prototype.aa = function (a) {
        NativeUI.n(this.j, a);
    };
    LabelView.$t = markType(LabelView, 'LabelView');
    return LabelView;
}(Base));
export { LabelView };
/**
 * @hidden
 */
var InputView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputView, _super);
    function InputView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.i = null;
        _this.b = null;
        _this.g = new List$1(Delegate_$type, 0);
        _this.d = false;
        _this.o = null;
        _this.c = true;
        _this.j = null;
        _this.k = null;
        return _this;
    }
    InputView.prototype.aj = function () {
    };
    InputView.prototype.e = function () {
        return true;
    };
    Object.defineProperty(InputView.prototype, "n", {
        get: function () {
            return this.j;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputView.prototype, "aw", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputView.prototype, "f", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    InputView.prototype.ag = function (a) {
        var e_9, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.g)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_9_1) {
                e_9 = { error: e_9_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_9)
                        throw e_9.error;
                }
            }
            this.g.clear();
        }
        this.i = a;
        this.i.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.i.createElement("input");
        c.setAttribute("type", this.a.bq);
        c.setStyleProperty("position", "relative");
        c.setStyleProperty("box-sizing", "border-box");
        c.setStyleProperty("display", "inline-block");
        c.setStyleProperty("border", "none");
        c.setStyleProperty("height", "2rem");
        c.setStyleProperty("line-height", "0");
        c.setStyleProperty("width", "100%");
        c.setStyleProperty("min-width", "0");
        c.setStyleProperty("overflow", "visible");
        c.setStyleProperty("background", "transparent");
        c.setStyleProperty("background-position-x", "initial");
        c.setStyleProperty("background-position-y", "initial");
        c.setStyleProperty("background-size", "initial");
        c.setStyleProperty("background-repeat-x", "initial");
        c.setStyleProperty("background-repeat-y", "initial");
        c.setStyleProperty("background-attachment", "initial");
        c.setStyleProperty("background-origin", "initial");
        c.setStyleProperty("background-color", "transparent");
        NativeUI.n(c, this.a.c7);
        c.setStyleProperty("outline-style", "none");
        c.setStyleProperty("box-shadow", "none");
        c.setStyleProperty("border-top", "0.1875rem solid transparent");
        c.setStyleProperty("padding-bottom", "0.1875rem");
        c.setStyleProperty("font-family", "'Segoe UI', Verdana");
        c.setStyleProperty("font-size", "1rem");
        this.g.add(c.listen("change", runOn(this, this.u)));
        this.g.add(c.listen("input", runOn(this, this.v)));
        this.g.add(c.listen("focus", runOn(this, this.aa)));
        this.g.add(c.listen("blur", runOn(this, this.t)));
        this.g.add(c.listen("mouseenter", runOn(this, this.r)));
        this.g.add(c.listen("mouseleave", runOn(this, this.s)));
        this.g.add(c.listen("keydown", runOn(this, this.ab)));
        this.g.add(c.listen("keyup", runOn(this, this.ad)));
        this.g.add(c.listen("keypress", runOn(this, this.ac)));
        this.g.add(c.listen("paste", runOn(this, this.ae)));
        this.g.add(c.listen("dragenter", runOn(this, this.y)));
        this.g.add(c.listen("dragleave", runOn(this, this.z)));
        this.g.add(c.listen("compositionstart", runOn(this, this.x)));
        this.g.add(c.listen("compositionend", runOn(this, this.w)));
        this.j = c;
        this.i.append(this.j);
        this.a.ct();
    };
    InputView.prototype.x = function (a) {
        this.d = true;
        this.a.ce();
    };
    InputView.prototype.w = function (a) {
        this.d = false;
        this.a.cd();
    };
    InputView.prototype.an = function () {
        this.j.setAttribute("type", this.a.bq);
        if (this.a.bq == "date") {
            this.j.setStyleProperty("line-height", "normal");
        }
        else {
            this.j.setStyleProperty("line-height", "0");
        }
    };
    InputView.prototype.al = function () {
        this.j.setAttribute("placeholder", this.a.bw);
    };
    InputView.prototype.at = function () {
        switch (this.a.k) {
            case 1:
                this.j.setStyleProperty("height", "2rem");
                this.j.setStyleProperty("font-size", "1rem");
                break;
            case 2:
                this.j.setStyleProperty("height", "1.68421rem");
                this.j.setStyleProperty("font-size", "1rem");
                break;
            case 3:
                this.j.setStyleProperty("height", "1.45455rem");
                this.j.setStyleProperty("font-size", ".95455rem");
                break;
        }
    };
    InputView.prototype.as = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.a.p == 2 ? (_this.h() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.z(this.i.rootWrapper, a);
        this.i.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    InputView.prototype.h = function () {
        var a = this.i.rootWrapper.getStyleProperty("height");
        var b = parseFloat(stringReplace(a, "px", ""));
        return b;
    };
    InputView.prototype.ao = function (a) {
        this.j.setProperty("value", a);
    };
    InputView.prototype.t = function (a) {
        this.a.ca();
    };
    InputView.prototype.aa = function (a) {
        this.a.ci();
    };
    InputView.prototype.u = function (a) {
        this.a.cb();
    };
    InputView.prototype.v = function (a) {
        this.a.cc();
    };
    InputView.prototype.ab = function (a) {
        var b = new KeyEventArgs(0, a);
        this.a.ck(b);
    };
    InputView.prototype.ad = function (a) {
        var b = new KeyEventArgs(0, a);
        this.a.cm(b);
    };
    InputView.prototype.ac = function (a) {
        var b = new KeyEventArgs(0, a);
        this.a.cl(b);
    };
    InputView.prototype.ae = function (a) {
        this.a.cp();
    };
    InputView.prototype.y = function (a) {
        this.a.cg();
    };
    InputView.prototype.z = function (a) {
        this.a.ch();
    };
    InputView.prototype.au = function (a) {
        if (this.o != a) {
            this.o = a;
            if (this.k != null) {
                this.k.setAttribute("d", this.o);
            }
        }
    };
    InputView.prototype.p = function () {
        return this.j.getProperty("value");
    };
    InputView.prototype.q = function (a) {
    };
    InputView.prototype.m = function () {
        var a = this.j.getProperty("selectionStart");
        return typeGetValue(a);
    };
    InputView.prototype.l = function () {
        var a = this.j.getProperty("selectionEnd");
        return typeGetValue(a);
    };
    InputView.prototype.ar = function (a) {
        this.j.setProperty("selectionStart", a);
    };
    InputView.prototype.ap = function (a) {
        this.j.setProperty("selectionEnd", a);
    };
    InputView.prototype.ak = function () {
        if (this.e()) {
        }
    };
    InputView.prototype.r = function (a) {
        this.a.cn();
    };
    InputView.prototype.s = function (a) {
        this.a.co();
    };
    InputView.prototype.af = function () {
        this.c = true;
        this.g.add(this.j.listen("change", runOn(this, this.u)));
        this.g.add(this.j.listen("input", runOn(this, this.v)));
        this.g.add(this.j.listen("focus", runOn(this, this.aa)));
        this.g.add(this.j.listen("blur", runOn(this, this.t)));
        this.g.add(this.j.listen("mouseenter", runOn(this, this.r)));
        this.g.add(this.j.listen("mouseleave", runOn(this, this.s)));
        this.g.add(this.j.listen("keydown", runOn(this, this.ab)));
        this.g.add(this.j.listen("paste", runOn(this, this.ae)));
        this.g.add(this.j.listen("dragenter", runOn(this, this.y)));
        this.g.add(this.j.listen("dragleave", runOn(this, this.z)));
        this.g.add(this.j.listen("compositionstart", runOn(this, this.x)));
        this.g.add(this.j.listen("compositionend", runOn(this, this.w)));
    };
    InputView.prototype.ah = function () {
        var e_10, _a;
        this.c = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.g)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_10_1) {
            e_10 = { error: e_10_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_10)
                    throw e_10.error;
            }
        }
        this.g.clear();
    };
    InputView.prototype.av = function (a) {
        if (a != null) {
            this.j.setStyleProperty("font", a.fontString);
        }
    };
    InputView.prototype.ai = function () {
        if (this.j != null) {
            this.j.focus(false);
        }
    };
    InputView.prototype.am = function () {
        if (this.j != null) {
            var nativeInput_ = this.j;
            nativeInput_.getNativeElement().select();
        }
    };
    InputView.prototype.aq = function (a, b) {
        if (this.j != null) {
            var c = this.j.getNativeElement();
            c.setSelectionRange(a, b);
        }
    };
    InputView.$t = markType(InputView, 'InputView');
    return InputView;
}(Base));
export { InputView };
/**
 * @hidden
 */
var InputGroupItem = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputGroupItem, _super);
    function InputGroupItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.c = null;
        _this.a = null;
        _this.propertyChanged = null;
        return _this;
    }
    Object.defineProperty(InputGroupItem.prototype, "e", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.g("Name", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupItem.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.g("InputGroup", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    InputGroupItem.prototype.g = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.h(a, b, c);
    };
    InputGroupItem.prototype.h = function (a, b, c) {
    };
    InputGroupItem.$t = markType(InputGroupItem, 'InputGroupItem', Base.$, [INotifyPropertyChanged_$type]);
    return InputGroupItem;
}(Base));
export { InputGroupItem };
/**
 * @hidden
 */
var Suffix = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Suffix, _super);
    function Suffix() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.i = 0;
        _this.t = "ig-suffix-" + Suffix.r++;
        _this.s = null;
        _this.m = false;
        _this.l = false;
        _this.n = false;
        var a = new SuffixView();
        a.a = _this;
        _this.view = a;
        _this.view.o();
        return _this;
    }
    Object.defineProperty(Suffix.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Suffix.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(Suffix.prototype, "j", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            var b = this.i;
            this.i = a;
            if (b != this.i) {
                this.g("ShiftType", enumGetBox(SuffixShiftType_$type, b), enumGetBox(SuffixShiftType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Suffix.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "InputGroup":
                this.af();
                break;
            case "ShiftType":
                this.ai();
                break;
        }
    };
    Suffix.prototype.ai = function () {
        this.view.q();
    };
    Suffix.prototype.af = function () {
        this.view.q();
    };
    Suffix.prototype.am = function () {
    };
    Suffix.prototype.al = function () {
    };
    Suffix.prototype.ag = function () {
        this.p = true;
    };
    Suffix.prototype.ah = function () {
        this.p = false;
    };
    Object.defineProperty(Suffix.prototype, "w", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            var b = this.t;
            this.t = a;
            if (b != this.t) {
                this.g("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suffix.prototype, "u", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            var b = this.s;
            this.s = a;
            if (b != this.s) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suffix.prototype, "p", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suffix.prototype, "disabled", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            var b = this.l;
            this.l = a;
            if (b != this.l) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Suffix.prototype.aj = function () {
    };
    Suffix.prototype.onDetachedFromUI = function () {
        this.view.n();
    };
    Suffix.prototype.onAttachedToUI = function () {
        this.view.l();
    };
    Suffix.prototype.q = function () {
        return this.view.d();
    };
    Suffix.prototype.appendContentChild = function (a) {
        this.view.k(a);
    };
    Suffix.prototype.provideContainer = function (a) {
        this.view.m(a);
    };
    Suffix.$t = markType(Suffix, 'Suffix', InputGroupItem.$);
    Suffix.r = 0;
    return Suffix;
}(InputGroupItem));
export { Suffix };
/**
 * @hidden
 */
var Prefix = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Prefix, _super);
    function Prefix() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.i = 0;
        _this.t = "ig-prefix-" + Prefix.r++;
        _this.s = null;
        _this.m = false;
        _this.l = false;
        _this.n = false;
        var a = new PrefixView();
        a.a = _this;
        _this.view = a;
        _this.view.o();
        return _this;
    }
    Object.defineProperty(Prefix.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Prefix.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(Prefix.prototype, "j", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            var b = this.i;
            this.i = a;
            if (b != this.i) {
                this.g("ShiftType", enumGetBox(PrefixShiftType_$type, b), enumGetBox(PrefixShiftType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Prefix.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "InputGroup":
                this.af();
                break;
            case "ShiftType":
                this.ai();
                break;
        }
    };
    Prefix.prototype.ai = function () {
        this.view.q();
    };
    Prefix.prototype.af = function () {
        this.view.q();
    };
    Prefix.prototype.am = function () {
    };
    Prefix.prototype.al = function () {
    };
    Prefix.prototype.ag = function () {
        this.p = true;
    };
    Prefix.prototype.ah = function () {
        this.p = false;
    };
    Object.defineProperty(Prefix.prototype, "w", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            var b = this.t;
            this.t = a;
            if (b != this.t) {
                this.g("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Prefix.prototype, "u", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            var b = this.s;
            this.s = a;
            if (b != this.s) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Prefix.prototype, "p", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Prefix.prototype, "disabled", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            var b = this.l;
            this.l = a;
            if (b != this.l) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Prefix.prototype.aj = function () {
    };
    Prefix.prototype.onDetachedFromUI = function () {
        this.view.n();
    };
    Prefix.prototype.onAttachedToUI = function () {
        this.view.l();
    };
    Prefix.prototype.q = function () {
        return this.view.d();
    };
    Prefix.prototype.appendContentChild = function (a) {
        this.view.k(a);
    };
    Prefix.prototype.provideContainer = function (a) {
        this.view.m(a);
    };
    Prefix.$t = markType(Prefix, 'Prefix', InputGroupItem.$);
    Prefix.r = 0;
    return Prefix;
}(InputGroupItem));
export { Prefix };
/**
 * @hidden
 */
var InputGroup = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputGroup, _super);
    function InputGroup() {
        var _this = _super.call(this) || this;
        _this.i = 0;
        _this.f = 1;
        _this.e = 1;
        _this.b = 0;
        _this._view = null;
        _this.p = null;
        _this.n = null;
        _this.lostFocus = null;
        _this.gotFocus = null;
        _this.db = ThemeResolver.b(InputGroup.c, InputGroup.fq, InputGroup.dx);
        _this.e1 = ThemeResolver.b(InputGroup.c, InputGroup.f1, InputGroup.d8);
        _this.mx = ThemeResolver.d(InputGroup.c, InputGroup.m6, InputGroup.m0);
        _this.td = ThemeResolver.f(InputGroup.c, InputGroup.tm, InputGroup.tg);
        _this.o6 = ThemeResolver.e(InputGroup.c, InputGroup.q4, InputGroup.po);
        _this.qr = ThemeResolver.e(InputGroup.c, InputGroup.rl, InputGroup.p5);
        _this.qs = ThemeResolver.e(InputGroup.c, InputGroup.rm, InputGroup.p6);
        _this.g7 = ThemeResolver.b(InputGroup.c, InputGroup.gt, InputGroup.e0);
        _this.g6 = ThemeResolver.b(InputGroup.c, InputGroup.gs, InputGroup.ez);
        _this.e5 = ThemeResolver.b(InputGroup.c, InputGroup.f5, InputGroup.ec);
        _this.sf = ThemeResolver.e(InputGroup.c, InputGroup.r5, InputGroup.qp);
        _this.sg = ThemeResolver.e(InputGroup.c, InputGroup.r6, InputGroup.qq);
        _this.qu = ThemeResolver.e(InputGroup.c, InputGroup.ro, InputGroup.p8);
        _this.qt = ThemeResolver.e(InputGroup.c, InputGroup.rn, InputGroup.p7);
        _this.g4 = ThemeResolver.b(InputGroup.c, InputGroup.gq, InputGroup.ex);
        _this.e4 = ThemeResolver.b(InputGroup.c, InputGroup.f4, InputGroup.eb);
        _this.e2 = ThemeResolver.b(InputGroup.c, InputGroup.f2, InputGroup.d9);
        _this.e3 = ThemeResolver.b(InputGroup.c, InputGroup.f3, InputGroup.ea);
        _this.g5 = ThemeResolver.b(InputGroup.c, InputGroup.gr, InputGroup.ey);
        _this.o5 = ThemeResolver.e(InputGroup.c, InputGroup.q3, InputGroup.pn);
        _this.e6 = ThemeResolver.b(InputGroup.c, InputGroup.f6, InputGroup.ed);
        _this.e7 = ThemeResolver.b(InputGroup.c, InputGroup.f7, InputGroup.ee);
        _this.m3 = ThemeResolver.d(InputGroup.c, InputGroup.m7, InputGroup.m1);
        _this.tj = ThemeResolver.f(InputGroup.c, InputGroup.tn, InputGroup.th);
        _this.qw = ThemeResolver.e(InputGroup.c, InputGroup.rq, InputGroup.qa);
        _this.qx = ThemeResolver.e(InputGroup.c, InputGroup.rr, InputGroup.qb);
        _this.qy = ThemeResolver.e(InputGroup.c, InputGroup.rs, InputGroup.qc);
        _this.ff = ThemeResolver.b(InputGroup.c, InputGroup.gf, InputGroup.em);
        _this.fe = ThemeResolver.b(InputGroup.c, InputGroup.ge, InputGroup.el);
        _this.fb = ThemeResolver.b(InputGroup.c, InputGroup.gb, InputGroup.ei);
        _this.q1 = ThemeResolver.e(InputGroup.c, InputGroup.rv, InputGroup.qf);
        _this.q2 = ThemeResolver.e(InputGroup.c, InputGroup.rw, InputGroup.qg);
        _this.q0 = ThemeResolver.e(InputGroup.c, InputGroup.ru, InputGroup.qe);
        _this.qz = ThemeResolver.e(InputGroup.c, InputGroup.rt, InputGroup.qd);
        _this.fc = ThemeResolver.b(InputGroup.c, InputGroup.gc, InputGroup.ej);
        _this.fa = ThemeResolver.b(InputGroup.c, InputGroup.ga, InputGroup.eh);
        _this.e8 = ThemeResolver.b(InputGroup.c, InputGroup.f8, InputGroup.ef);
        _this.e9 = ThemeResolver.b(InputGroup.c, InputGroup.f9, InputGroup.eg);
        _this.fd = ThemeResolver.b(InputGroup.c, InputGroup.gd, InputGroup.ek);
        _this.qv = ThemeResolver.e(InputGroup.c, InputGroup.rp, InputGroup.p9);
        _this.dc = ThemeResolver.b(InputGroup.c, InputGroup.fr, InputGroup.dy);
        _this.dd = ThemeResolver.b(InputGroup.c, InputGroup.fs, InputGroup.dz);
        _this.mw = ThemeResolver.d(InputGroup.c, InputGroup.m5, InputGroup.mz);
        _this.tc = ThemeResolver.f(InputGroup.c, InputGroup.tl, InputGroup.tf);
        _this.pg = ThemeResolver.e(InputGroup.c, InputGroup.re, InputGroup.py);
        _this.ph = ThemeResolver.e(InputGroup.c, InputGroup.rf, InputGroup.pz);
        _this.pi = ThemeResolver.e(InputGroup.c, InputGroup.rg, InputGroup.p0);
        _this.dl = ThemeResolver.b(InputGroup.c, InputGroup.f0, InputGroup.d7);
        _this.dk = ThemeResolver.b(InputGroup.c, InputGroup.fz, InputGroup.d6);
        _this.dh = ThemeResolver.b(InputGroup.c, InputGroup.fw, InputGroup.d3);
        _this.pl = ThemeResolver.e(InputGroup.c, InputGroup.rj, InputGroup.p3);
        _this.pm = ThemeResolver.e(InputGroup.c, InputGroup.rk, InputGroup.p4);
        _this.pk = ThemeResolver.e(InputGroup.c, InputGroup.ri, InputGroup.p2);
        _this.pj = ThemeResolver.e(InputGroup.c, InputGroup.rh, InputGroup.p1);
        _this.di = ThemeResolver.b(InputGroup.c, InputGroup.fx, InputGroup.d4);
        _this.dg = ThemeResolver.b(InputGroup.c, InputGroup.fv, InputGroup.d2);
        _this.de = ThemeResolver.b(InputGroup.c, InputGroup.ft, InputGroup.d0);
        _this.df = ThemeResolver.b(InputGroup.c, InputGroup.fu, InputGroup.d1);
        _this.dj = ThemeResolver.b(InputGroup.c, InputGroup.fy, InputGroup.d5);
        _this.pf = ThemeResolver.e(InputGroup.c, InputGroup.rd, InputGroup.px);
        _this.c1 = ThemeResolver.b(InputGroup.c, InputGroup.fg, InputGroup.dm);
        _this.c2 = ThemeResolver.b(InputGroup.c, InputGroup.fh, InputGroup.dn);
        _this.mv = ThemeResolver.d(InputGroup.c, InputGroup.m4, InputGroup.my);
        _this.tb = ThemeResolver.f(InputGroup.c, InputGroup.tk, InputGroup.te);
        _this.o8 = ThemeResolver.e(InputGroup.c, InputGroup.q6, InputGroup.pq);
        _this.o9 = ThemeResolver.e(InputGroup.c, InputGroup.q7, InputGroup.pr);
        _this.pa = ThemeResolver.e(InputGroup.c, InputGroup.q8, InputGroup.ps);
        _this.da = ThemeResolver.b(InputGroup.c, InputGroup.fp, InputGroup.dw);
        _this.c9 = ThemeResolver.b(InputGroup.c, InputGroup.fo, InputGroup.dv);
        _this.c6 = ThemeResolver.b(InputGroup.c, InputGroup.fl, InputGroup.ds);
        _this.pd = ThemeResolver.e(InputGroup.c, InputGroup.rb, InputGroup.pv);
        _this.pe = ThemeResolver.e(InputGroup.c, InputGroup.rc, InputGroup.pw);
        _this.pc = ThemeResolver.e(InputGroup.c, InputGroup.ra, InputGroup.pu);
        _this.pb = ThemeResolver.e(InputGroup.c, InputGroup.q9, InputGroup.pt);
        _this.c7 = ThemeResolver.b(InputGroup.c, InputGroup.fm, InputGroup.dt);
        _this.c5 = ThemeResolver.b(InputGroup.c, InputGroup.fk, InputGroup.dr);
        _this.c3 = ThemeResolver.b(InputGroup.c, InputGroup.fi, InputGroup.dp);
        _this.c4 = ThemeResolver.b(InputGroup.c, InputGroup.fj, InputGroup.dq);
        _this.c8 = ThemeResolver.b(InputGroup.c, InputGroup.fn, InputGroup.du);
        _this.o7 = ThemeResolver.e(InputGroup.c, InputGroup.q5, InputGroup.pp);
        _this.gu = ThemeResolver.b(InputGroup.c, InputGroup.gg, InputGroup.en);
        _this.gv = ThemeResolver.b(InputGroup.c, InputGroup.gh, InputGroup.eo);
        _this.m9 = ThemeResolver.d(InputGroup.c, InputGroup.m8, InputGroup.m2);
        _this.tp = ThemeResolver.f(InputGroup.c, InputGroup.to, InputGroup.ti);
        _this.r8 = ThemeResolver.e(InputGroup.c, InputGroup.ry, InputGroup.qi);
        _this.r9 = ThemeResolver.e(InputGroup.c, InputGroup.rz, InputGroup.qj);
        _this.sa = ThemeResolver.e(InputGroup.c, InputGroup.r0, InputGroup.qk);
        _this.g3 = ThemeResolver.b(InputGroup.c, InputGroup.gp, InputGroup.ew);
        _this.g2 = ThemeResolver.b(InputGroup.c, InputGroup.go, InputGroup.ev);
        _this.gz = ThemeResolver.b(InputGroup.c, InputGroup.gl, InputGroup.es);
        _this.sd = ThemeResolver.e(InputGroup.c, InputGroup.r3, InputGroup.qn);
        _this.se = ThemeResolver.e(InputGroup.c, InputGroup.r4, InputGroup.qo);
        _this.sc = ThemeResolver.e(InputGroup.c, InputGroup.r2, InputGroup.qm);
        _this.sb = ThemeResolver.e(InputGroup.c, InputGroup.r1, InputGroup.ql);
        _this.g0 = ThemeResolver.b(InputGroup.c, InputGroup.gm, InputGroup.et);
        _this.gy = ThemeResolver.b(InputGroup.c, InputGroup.gk, InputGroup.er);
        _this.gw = ThemeResolver.b(InputGroup.c, InputGroup.gi, InputGroup.ep);
        _this.gx = ThemeResolver.b(InputGroup.c, InputGroup.gj, InputGroup.eq);
        _this.g1 = ThemeResolver.b(InputGroup.c, InputGroup.gn, InputGroup.eu);
        _this.r7 = ThemeResolver.e(InputGroup.c, InputGroup.rx, InputGroup.qh);
        _this.nd = ThemeResolver.e(InputGroup.c, InputGroup.q4, InputGroup.po);
        _this.ne = ThemeResolver.e(InputGroup.c, InputGroup.rl, InputGroup.p5);
        _this.ai = ThemeResolver.b(InputGroup.c, InputGroup.fq, InputGroup.dx);
        _this.aj = ThemeResolver.b(InputGroup.c, InputGroup.f1, InputGroup.d8);
        _this.mk = ThemeResolver.d(InputGroup.c, InputGroup.m6, InputGroup.m0);
        _this.s0 = ThemeResolver.f(InputGroup.c, InputGroup.tm, InputGroup.tg);
        _this.ar = ThemeResolver.b(InputGroup.c, InputGroup.gt, InputGroup.e0);
        _this.aq = ThemeResolver.b(InputGroup.c, InputGroup.gs, InputGroup.ez);
        _this.an = ThemeResolver.b(InputGroup.c, InputGroup.f5, InputGroup.ec);
        _this.nh = ThemeResolver.e(InputGroup.c, InputGroup.r5, InputGroup.qp);
        _this.ni = ThemeResolver.e(InputGroup.c, InputGroup.r6, InputGroup.qq);
        _this.ng = ThemeResolver.e(InputGroup.c, InputGroup.ro, InputGroup.p8);
        _this.nf = ThemeResolver.e(InputGroup.c, InputGroup.rn, InputGroup.p7);
        _this.ao = ThemeResolver.b(InputGroup.c, InputGroup.gq, InputGroup.ex);
        _this.am = ThemeResolver.b(InputGroup.c, InputGroup.f4, InputGroup.eb);
        _this.ak = ThemeResolver.b(InputGroup.c, InputGroup.f2, InputGroup.d9);
        _this.al = ThemeResolver.b(InputGroup.c, InputGroup.f3, InputGroup.ea);
        _this.ap = ThemeResolver.b(InputGroup.c, InputGroup.gr, InputGroup.ey);
        _this.nc = ThemeResolver.e(InputGroup.c, InputGroup.q3, InputGroup.pn);
        _this.a2 = NaN;
        _this.bd = NaN;
        _this.nk = null;
        _this.mn = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.s3 = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.b5 = NaN;
        _this.b4 = NaN;
        _this.bh = NaN;
        _this.og = null;
        _this.oh = null;
        _this.n1 = null;
        _this.n0 = null;
        _this.b2 = NaN;
        _this.bg = NaN;
        _this.be = NaN;
        _this.bf = NaN;
        _this.b3 = NaN;
        _this.nj = null;
        _this.bi = NaN;
        _this.bj = NaN;
        _this.n4 = null;
        _this.n3 = null;
        _this.mo = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.s4 = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.br = NaN;
        _this.bq = NaN;
        _this.bn = NaN;
        _this.n7 = null;
        _this.n8 = null;
        _this.n6 = null;
        _this.n5 = null;
        _this.bo = NaN;
        _this.bm = NaN;
        _this.bk = NaN;
        _this.bl = NaN;
        _this.bp = NaN;
        _this.n2 = null;
        _this.a3 = NaN;
        _this.a4 = NaN;
        _this.nu = null;
        _this.nt = null;
        _this.mm = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.s2 = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.bc = NaN;
        _this.bb = NaN;
        _this.a8 = NaN;
        _this.nx = null;
        _this.ny = null;
        _this.nw = null;
        _this.nv = null;
        _this.a9 = NaN;
        _this.a7 = NaN;
        _this.a5 = NaN;
        _this.a6 = NaN;
        _this.ba = NaN;
        _this.ns = null;
        _this.as = NaN;
        _this.at = NaN;
        _this.nn = null;
        _this.nm = null;
        _this.ml = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.s1 = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.a1 = NaN;
        _this.a0 = NaN;
        _this.ax = NaN;
        _this.nq = null;
        _this.nr = null;
        _this.np = null;
        _this.no = null;
        _this.ay = NaN;
        _this.aw = NaN;
        _this.au = NaN;
        _this.av = NaN;
        _this.az = NaN;
        _this.nl = null;
        _this.bs = NaN;
        _this.bt = NaN;
        _this.ob = null;
        _this.oa = null;
        _this.mp = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.s5 = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.b1 = NaN;
        _this.b0 = NaN;
        _this.bx = NaN;
        _this.oe = null;
        _this.of = null;
        _this.od = null;
        _this.oc = null;
        _this.by = NaN;
        _this.bw = NaN;
        _this.bu = NaN;
        _this.bv = NaN;
        _this.bz = NaN;
        _this.n9 = null;
        _this.w = false;
        _this.s = false;
        _this.y = false;
        _this.u = false;
        _this.x = false;
        _this.t = false;
        _this.q = false;
        _this.nz = null;
        _this.h4 = "ig-inputgroup-" + InputGroup.h3++;
        _this.v = false;
        _this.propertyChanged = null;
        _this.k = new InputGroupInputCollection();
        _this.o = null;
        _this.aa = false;
        _this.r = false;
        _this.z = false;
        var a = new InputGroupView();
        a.d = _this;
        _this.view = a;
        _this.view.ag();
        var b = _this.k;
        b.collectionChanged = delegateCombine(b.collectionChanged, runOn(_this, _this.lp));
        var c = _this.k;
        c.collectionResetting = delegateCombine(c.collectionResetting, runOn(_this, _this.lq));
        return _this;
    }
    InputGroup.prototype.lq = function (a, b) {
        this.md();
    };
    InputGroup.prototype.appendContentChild = function (a) {
        this.view.aa(a);
    };
    InputGroup.prototype.ma = function (a) {
        this.view.aj(a);
    };
    Object.defineProperty(InputGroup.prototype, "j", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            var b = this.i;
            this.i = a;
            if (b != this.i) {
                this.l5("DisplayType", enumGetBox(InputGroupDisplayType_$type, b), enumGetBox(InputGroupDisplayType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (b != this.f) {
                this.l5("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "g", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (b != this.e) {
                this.l5("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.lv = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Label.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    InputGroup.prototype.lw = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Prefix.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    InputGroup.prototype.lu = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Input.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    InputGroup.prototype.lx = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Suffix.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    InputGroup.prototype.lp = function (a, b) {
        var e_11, _a, e_12, _b;
        if (b.oldItems != null) {
            try {
                for (var _c = tslib_1.__values(fromEn(b.oldItems)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var c = _d.value;
                    var d = c;
                    if (d != null) {
                        d.b = null;
                    }
                }
            }
            catch (e_11_1) {
                e_11 = { error: e_11_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_11)
                        throw e_11.error;
                }
            }
        }
        if (b.newItems != null) {
            try {
                for (var _e = tslib_1.__values(fromEn(b.newItems)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var e = _f.value;
                    var f = e;
                    if (f != null) {
                        f.b = this;
                    }
                }
            }
            catch (e_12_1) {
                e_12 = { error: e_12_1 };
            }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return))
                        _b.call(_e);
                }
                finally {
                    if (e_12)
                        throw e_12.error;
                }
            }
        }
        this.mg();
        this.mf();
        this.mh();
        this.mi();
        this.md();
    };
    Object.defineProperty(InputGroup.prototype, "d", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.l5("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.destroy = function () {
        this.provideContainer(null);
    };
    InputGroup.prototype.l5 = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.l8(a, b, c);
    };
    InputGroup.prototype.l8 = function (a, b, c) {
        var _this = this;
        switch (a) {
            case "BaseTheme":
                this.mc(this.d);
                this.me();
                this.lv(function (d) { return d.l = _this.d == 0 ? 2 : _this.d; });
                break;
            case "ActualBorderColor":
            case "ActualBackgroundColor":
            case "ActualBorderWidth":
            case "ActualFocusBorderColor":
            case "ActualFocusBorderWidth":
            case "ActualCornerRadius":
            case "ActualContentPadding":
            case "ActualUnderlineOpacity":
            case "ActualUnderlineRippleOpacity":
            case "ActualUnderlineRippleWidth":
            case "ActualUnderlineRippleColor":
            case "ActualUnderlineColor":
            case "ActualHoverUnderlineColor":
            case "ActualUnderlineWidth":
            case "ActualHoverUnderlineWidth":
            case "ActualHoverUnderlineOpacity":
            case "ActualFocusUnderlineColor":
            case "ActualFocusUnderlineOpacity":
            case "ActualFocusUnderlineRippleOpacity":
            case "IsHovered":
                this.z = true;
                this.aa = true;
                this.r = true;
                this.md();
                break;
            case "BorderColor":
            case "BackgroundColor":
            case "BorderWidth":
            case "FocusBorderColor":
            case "FocusBorderWidth":
            case "CornerRadius":
            case "ContentPadding":
            case "UnderlineOpacity":
            case "UnderlineRippleOpacity":
            case "UnderlineRippleWidth":
            case "UnderlineRippleColor":
            case "UnderlineColor":
            case "HoverUnderlineColor":
            case "UnderlineWidth":
            case "HoverUnderlineWidth":
            case "HoverUnderlineOpacity":
            case "FocusUnderlineColor":
            case "FocusUnderlineOpacity":
            case "FocusUnderlineRippleOpacity":
            case "LineTypeBorderColor":
            case "LineTypeBackgroundColor":
            case "LineTypeBorderWidth":
            case "LineTypeFocusBorderColor":
            case "LineTypeFocusBorderWidth":
            case "LineTypeCornerRadius":
            case "LineTypeContentPadding":
            case "LineTypeUnderlineOpacity":
            case "LineTypeUnderlineRippleOpacity":
            case "LineTypeUnderlineRippleWidth":
            case "LineTypeUnderlineRippleColor":
            case "LineTypeUnderlineColor":
            case "LineTypeHoverUnderlineColor":
            case "LineTypeUnderlineWidth":
            case "LineTypeHoverUnderlineWidth":
            case "LineTypeHoverUnderlineOpacity":
            case "LineTypeFocusUnderlineColor":
            case "LineTypeFocusUnderlineOpacity":
            case "LineTypeFocusUnderlineRippleOpacity":
            case "BoxTypeBorderColor":
            case "BoxTypeBackgroundColor":
            case "BoxTypeBorderWidth":
            case "BoxTypeFocusBorderColor":
            case "BoxTypeFocusBorderWidth":
            case "BoxTypeCornerRadius":
            case "BoxTypeContentPadding":
            case "BoxTypeUnderlineOpacity":
            case "BoxTypeUnderlineRippleOpacity":
            case "BoxTypeUnderlineRippleWidth":
            case "BoxTypeUnderlineRippleColor":
            case "BoxTypeUnderlineColor":
            case "BoxTypeHoverUnderlineColor":
            case "BoxTypeUnderlineWidth":
            case "BoxTypeHoverUnderlineWidth":
            case "BoxTypeHoverUnderlineOpacity":
            case "BoxTypeFocusUnderlineColor":
            case "BoxTypeFocusUnderlineOpacity":
            case "BoxTypeFocusUnderlineRippleOpacity":
            case "BorderTypeBorderColor":
            case "BorderTypeBackgroundColor":
            case "BorderTypeBorderWidth":
            case "BorderTypeFocusBorderColor":
            case "BorderTypeFocusBorderWidth":
            case "BorderTypeCornerRadius":
            case "BorderTypeContentPadding":
            case "BorderTypeUnderlineOpacity":
            case "BorderTypeUnderlineRippleOpacity":
            case "BorderTypeUnderlineRippleWidth":
            case "BorderTypeUnderlineRippleColor":
            case "BorderTypeUnderlineColor":
            case "BorderTypeHoverUnderlineColor":
            case "BorderTypeUnderlineWidth":
            case "BorderTypeHoverUnderlineWidth":
            case "BorderTypeHoverUnderlineOpacity":
            case "BorderTypeFocusUnderlineColor":
            case "BorderTypeFocusUnderlineOpacity":
            case "BorderTypeFocusUnderlineRippleOpacity":
            case "DisplayType":
                this.me();
                break;
            case "ActualDensity":
                this.view.al();
                this.me();
                break;
            case "Density":
                this.g = this.h == 0 ? 1 : this.h;
                break;
            case "IsFocused":
                this.l3();
                this.md();
                break;
            case "IsExpanded":
                this.s = true;
                this.ab = this.ae;
                break;
            case "ActualIsExpanded":
                this.ly();
                break;
        }
    };
    InputGroup.mt = function (a, b) {
        return new CornerRadius(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b, !isNaN_(a.a) ? a.a : b.a);
    };
    InputGroup.s9 = function (a, b) {
        return new Thickness(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.e) ? a.e : b.e, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b);
    };
    InputGroup.prototype.mg = function () {
        var _this = this;
        this.lv(function (a) {
            a.p = _this.g;
            a.l = _this.d == 0 ? 2 : _this.d;
            switch (_this.j) {
                case 0:
                    a.r = 0;
                    break;
                case 1:
                    a.r = 1;
                    break;
                case 2:
                case 3:
                    a.r = 2;
                    break;
            }
        });
    };
    InputGroup.prototype.mh = function () {
        var _this = this;
        this.lw(function (a) {
            switch (_this.j) {
                case 0:
                    a.j = 0;
                    break;
                case 1:
                    a.j = 1;
                    break;
                case 2:
                case 3:
                    a.j = 2;
                    break;
            }
        });
    };
    InputGroup.prototype.mf = function () {
        var _this = this;
        this.lu(function (a) {
            a.l = _this.g;
            switch (_this.j) {
                case 0:
                    a.p = 0;
                    break;
                case 1:
                    a.p = 1;
                    break;
                case 2:
                case 3:
                    a.p = 2;
                    break;
            }
        });
    };
    InputGroup.prototype.mi = function () {
        var _this = this;
        this.lx(function (a) {
            switch (_this.j) {
                case 0:
                    a.j = 0;
                    break;
                case 1:
                    a.j = 1;
                    break;
                case 2:
                case 3:
                    a.j = 2;
                    break;
            }
        });
    };
    InputGroup.prototype.me = function () {
        this.mg();
        this.mf();
        this.mh();
        this.mi();
        switch (this.j) {
            case 0:
                this.oj = this.oq != null ? this.oq : this.sl != null ? this.sl : this.qw;
                this.oi = this.op != null ? this.op : this.sk != null ? this.sk : this.qv;
                this.b6 = !isNaN_(this.cq) ? this.cq : !isNaN_(this.hd) ? this.hd : this.e6;
                this.ok = this.sh != null ? this.sh : this.sm != null ? this.sm : this.qx;
                this.b7 = !isNaN_(this.g8) ? this.g8 : !isNaN_(this.he) ? this.he : this.e7;
                this.mq = InputGroup.mt(this.mu, InputGroup.mt(this.na, this.m3));
                this.s6 = InputGroup.s9(this.ta, InputGroup.s9(this.tq, this.tj));
                this.cc = !isNaN_(this.hx) ? this.hx : !isNaN_(this.hj) ? this.hj : this.fc;
                this.cd = !isNaN_(this.hy) ? this.hy : !isNaN_(this.hk) ? this.hk : this.fd;
                this.ce = !isNaN_(this.hz) ? this.hz : !isNaN_(this.hl) ? this.hl : this.fe;
                this.oo = this.sz != null ? this.sz : this.sq != null ? this.sq : this.q2;
                this.on = this.sy != null ? this.sy : this.sp != null ? this.sp : this.q1;
                this.om = this.sj != null ? this.sj : this.so != null ? this.so : this.q0;
                this.cf = !isNaN_(this.h0) ? this.h0 : !isNaN_(this.hm) ? this.hm : this.ff;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.hi) ? this.hi : this.fb;
                this.ca = !isNaN_(this.hb) ? this.hb : !isNaN_(this.hh) ? this.hh : this.fa;
                this.ol = this.si != null ? this.si : this.sn != null ? this.sn : this.qz;
                this.b8 = !isNaN_(this.g9) ? this.g9 : !isNaN_(this.hf) ? this.hf : this.e8;
                this.b9 = !isNaN_(this.ha) ? this.ha : !isNaN_(this.hg) ? this.hg : this.e9;
                break;
            case 1:
                this.oj = this.oq != null ? this.oq : this.oz != null ? this.oz : this.pg;
                this.oi = this.op != null ? this.op : this.oy != null ? this.oy : this.pf;
                this.b6 = !isNaN_(this.cq) ? this.cq : !isNaN_(this.cr) ? this.cr : this.dc;
                this.ok = this.sh != null ? this.sh : this.o0 != null ? this.o0 : this.ph;
                this.b7 = !isNaN_(this.g8) ? this.g8 : !isNaN_(this.cs) ? this.cs : this.dd;
                this.mq = InputGroup.mt(this.mu, InputGroup.mt(this.ms, this.mw));
                this.s6 = InputGroup.s9(this.ta, InputGroup.s9(this.s8, this.tc));
                this.cc = !isNaN_(this.hx) ? this.hx : !isNaN_(this.cx) ? this.cx : this.di;
                this.cd = !isNaN_(this.hy) ? this.hy : !isNaN_(this.cy) ? this.cy : this.dj;
                this.ce = !isNaN_(this.hz) ? this.hz : !isNaN_(this.cz) ? this.cz : this.dk;
                this.oo = this.sz != null ? this.sz : this.o4 != null ? this.o4 : this.pm;
                this.on = this.sy != null ? this.sy : this.o3 != null ? this.o3 : this.pl;
                this.om = this.sj != null ? this.sj : this.o2 != null ? this.o2 : this.pk;
                this.cf = !isNaN_(this.h0) ? this.h0 : !isNaN_(this.c0) ? this.c0 : this.dl;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.cw) ? this.cw : this.dh;
                this.ca = !isNaN_(this.hb) ? this.hb : !isNaN_(this.cv) ? this.cv : this.dg;
                this.ol = this.si != null ? this.si : this.o1 != null ? this.o1 : this.pj;
                this.b8 = !isNaN_(this.g9) ? this.g9 : !isNaN_(this.ct) ? this.ct : this.de;
                this.b9 = !isNaN_(this.ha) ? this.ha : !isNaN_(this.cu) ? this.cu : this.df;
                break;
            case 2:
                this.oj = this.oq != null ? this.oq : this.os != null ? this.os : this.o8;
                this.oi = this.op != null ? this.op : this.or != null ? this.or : this.o7;
                this.b6 = !isNaN_(this.cq) ? this.cq : !isNaN_(this.cg) ? this.cg : this.c1;
                this.ok = this.sh != null ? this.sh : this.ot != null ? this.ot : this.o9;
                this.b7 = !isNaN_(this.g8) ? this.g8 : !isNaN_(this.ch) ? this.ch : this.c2;
                this.mq = InputGroup.mt(this.mu, InputGroup.mt(this.mr, this.mv));
                this.s6 = InputGroup.s9(this.ta, InputGroup.s9(this.s7, this.tb));
                this.cc = !isNaN_(this.hx) ? this.hx : !isNaN_(this.cm) ? this.cm : this.c7;
                this.cd = !isNaN_(this.hy) ? this.hy : !isNaN_(this.cn) ? this.cn : this.c8;
                this.ce = !isNaN_(this.hz) ? this.hz : !isNaN_(this.co) ? this.co : this.c9;
                this.oo = this.sz != null ? this.sz : this.ox != null ? this.ox : this.pe;
                this.on = this.sy != null ? this.sy : this.ow != null ? this.ow : this.pd;
                this.om = this.sj != null ? this.sj : this.ov != null ? this.ov : this.pc;
                this.cf = !isNaN_(this.h0) ? this.h0 : !isNaN_(this.cp) ? this.cp : this.da;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.cl) ? this.cl : this.c6;
                this.ca = !isNaN_(this.hb) ? this.hb : !isNaN_(this.ck) ? this.ck : this.c5;
                this.ol = this.si != null ? this.si : this.ou != null ? this.ou : this.pb;
                this.b8 = !isNaN_(this.g9) ? this.g9 : !isNaN_(this.ci) ? this.ci : this.c3;
                this.b9 = !isNaN_(this.ha) ? this.ha : !isNaN_(this.cj) ? this.cj : this.c4;
                break;
            case 3:
                this.oj = this.oq != null ? this.oq : this.ss != null ? this.ss : this.r8;
                this.oi = this.op != null ? this.op : this.sr != null ? this.sr : this.r7;
                this.b6 = !isNaN_(this.cq) ? this.cq : !isNaN_(this.hn) ? this.hn : this.gu;
                this.ok = this.sh != null ? this.sh : this.st != null ? this.st : this.r9;
                this.b7 = !isNaN_(this.g8) ? this.g8 : !isNaN_(this.ho) ? this.ho : this.gv;
                this.mq = InputGroup.mt(this.mu, InputGroup.mt(this.nb, this.m9));
                this.s6 = InputGroup.s9(this.ta, InputGroup.s9(this.tr, this.tp));
                this.cc = !isNaN_(this.hx) ? this.hx : !isNaN_(this.ht) ? this.ht : this.g0;
                this.cd = !isNaN_(this.hy) ? this.hy : !isNaN_(this.hu) ? this.hu : this.g1;
                this.ce = !isNaN_(this.hz) ? this.hz : !isNaN_(this.hv) ? this.hv : this.g2;
                this.oo = this.sz != null ? this.sz : this.sx != null ? this.sx : this.se;
                this.on = this.sy != null ? this.sy : this.sw != null ? this.sw : this.sd;
                this.om = this.sj != null ? this.sj : this.sv != null ? this.sv : this.sc;
                this.cf = !isNaN_(this.h0) ? this.h0 : !isNaN_(this.hw) ? this.hw : this.g3;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.hs) ? this.hs : this.gz;
                this.ca = !isNaN_(this.hb) ? this.hb : !isNaN_(this.hr) ? this.hr : this.gy;
                this.ol = this.si != null ? this.si : this.su != null ? this.su : this.sb;
                this.b8 = !isNaN_(this.g9) ? this.g9 : !isNaN_(this.hp) ? this.hp : this.gw;
                this.b9 = !isNaN_(this.ha) ? this.ha : !isNaN_(this.hq) ? this.hq : this.gx;
                break;
        }
    };
    InputGroup.prototype.md = function () {
        this.lv(function (a) {
        });
        this.lu(function (a) {
        });
        var a = this.view.u;
        var b = this.view.t;
        var c = this.view.w;
        var d = this.view.x;
        var e = this.o != null && this.o.playState == 1;
        var f = this.p != null && this.p.playState == 1;
        var g = this.n != null && this.n.playState == 1;
        NativeUI.l(a, this.mq);
        NativeUI.l(b, this.mq);
        NativeUI.j(a, this.oi);
        NativeUI.u(a, this.s6);
        if (this.af) {
            if (!g) {
                NativeUI.k(b, this.ok);
                NativeUI.m(b, new Thickness(0, this.b7));
            }
            if (!f) {
                NativeUI.j(c, this.ol);
            }
        }
        else {
            if (!f) {
                if (this.ag) {
                    NativeUI.j(c, this.om);
                    NativeUI.t(c, this.ca);
                    NativeUI.q(c, this.cb);
                }
                else {
                    NativeUI.j(c, this.on);
                    NativeUI.t(c, this.cc);
                    NativeUI.q(c, this.cf);
                }
            }
            if (!g) {
                NativeUI.k(b, this.oj);
                NativeUI.m(b, new Thickness(0, this.b6));
            }
            if (!f) {
                NativeUI.j(a, this.oi);
            }
        }
        if (!e) {
            NativeUI.j(d, this.oo);
            NativeUI.q(d, this.ce);
            NativeUI.t(d, this.cd);
        }
    };
    Object.defineProperty(InputGroup.prototype, "a", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.onChildrenMutated = function () {
        this.lu(function (a) { return a.view.as(); });
        this.lv(function (a) { return a.view.ac(); });
        this.lw(function (a) { return a.view.q(); });
        this.lx(function (a) { return a.view.q(); });
    };
    InputGroup.prototype.lt = function () {
        this.view.ab();
        var a = false;
        if (this.p == null) {
            this.p = KeyFrameAnimationFactory.f.c(this.view.c(this.a).m(new AnimationKeyFrameProperty(2, this.oj)).m(new AnimationKeyFrameProperty(2, this.ok)));
        }
        if (this.n == null) {
            this.n = KeyFrameAnimationFactory.f.c(this.view.a(this.a).m(new AnimationKeyFrameProperty(3, this.oj), new AnimationKeyFrameProperty(4, this.j == 2 || this.j == 3 ? new Thickness(0, this.b6) : new Thickness(0, 0))).m(new AnimationKeyFrameProperty(3, this.ok), new AnimationKeyFrameProperty(4, this.j == 2 || this.j == 3 ? new Thickness(0, this.b7) : new Thickness(0, 0))));
        }
        if (this.o == null) {
            this.o = KeyFrameAnimationFactory.f.c(this.view.b(this.a).m(new AnimationKeyFrameProperty(2, this.ok), new AnimationKeyFrameProperty(14, ((function () {
                var $ret = new ScaleTransform();
                $ret.l = 0.5;
                $ret.m = 1;
                return $ret;
            })())), new AnimationKeyFrameProperty(1, 0)).m(new AnimationKeyFrameProperty(2, this.ok), new AnimationKeyFrameProperty(14, ((function () {
                var $ret = new ScaleTransform();
                $ret.l = 1;
                $ret.m = 1;
                return $ret;
            })())), new AnimationKeyFrameProperty(1, 1)));
        }
    };
    Object.defineProperty(InputGroup.prototype, "ac", {
        get: function () {
            var a = false;
            this.lu(function (b) {
                if (b.ak) {
                    a = true;
                }
            });
            return a;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.l4 = function () {
        this.ab = this.s ? this.ae : this.ac ? true : false;
        this.af = false;
        if (null != this.lostFocus) {
            this.lostFocus(this, EventArgs.empty);
        }
    };
    InputGroup.prototype.mc = function (a) {
        this.db = ThemeResolver.b(a, InputGroup.fq, InputGroup.dx);
        this.e1 = ThemeResolver.b(a, InputGroup.f1, InputGroup.d8);
        this.mx = ThemeResolver.d(a, InputGroup.m6, InputGroup.m0);
        this.td = ThemeResolver.f(a, InputGroup.tm, InputGroup.tg);
        this.o6 = ThemeResolver.e(a, InputGroup.q4, InputGroup.po);
        this.qr = ThemeResolver.e(a, InputGroup.rl, InputGroup.p5);
        this.qs = ThemeResolver.e(a, InputGroup.rm, InputGroup.p6);
        this.g7 = ThemeResolver.b(a, InputGroup.gt, InputGroup.e0);
        this.g6 = ThemeResolver.b(a, InputGroup.gs, InputGroup.ez);
        this.e5 = ThemeResolver.b(a, InputGroup.f5, InputGroup.ec);
        this.sf = ThemeResolver.e(a, InputGroup.r5, InputGroup.qp);
        this.sg = ThemeResolver.e(a, InputGroup.r6, InputGroup.qq);
        this.qu = ThemeResolver.e(a, InputGroup.ro, InputGroup.p8);
        this.qt = ThemeResolver.e(a, InputGroup.rn, InputGroup.p7);
        this.g4 = ThemeResolver.b(a, InputGroup.gq, InputGroup.ex);
        this.e4 = ThemeResolver.b(a, InputGroup.f4, InputGroup.eb);
        this.e2 = ThemeResolver.b(a, InputGroup.f2, InputGroup.d9);
        this.e3 = ThemeResolver.b(a, InputGroup.f3, InputGroup.ea);
        this.g5 = ThemeResolver.b(a, InputGroup.gr, InputGroup.ey);
        this.o5 = ThemeResolver.e(a, InputGroup.q3, InputGroup.pn);
        this.e6 = ThemeResolver.b(a, InputGroup.f6, InputGroup.ed);
        this.e7 = ThemeResolver.b(a, InputGroup.f7, InputGroup.ee);
        this.m3 = ThemeResolver.d(a, InputGroup.m7, InputGroup.m1);
        this.tj = ThemeResolver.f(a, InputGroup.tn, InputGroup.th);
        this.qw = ThemeResolver.e(a, InputGroup.rq, InputGroup.qa);
        this.qx = ThemeResolver.e(a, InputGroup.rr, InputGroup.qb);
        this.qy = ThemeResolver.e(a, InputGroup.rs, InputGroup.qc);
        this.ff = ThemeResolver.b(a, InputGroup.gf, InputGroup.em);
        this.fe = ThemeResolver.b(a, InputGroup.ge, InputGroup.el);
        this.fb = ThemeResolver.b(a, InputGroup.gb, InputGroup.ei);
        this.q1 = ThemeResolver.e(a, InputGroup.rv, InputGroup.qf);
        this.q2 = ThemeResolver.e(a, InputGroup.rw, InputGroup.qg);
        this.q0 = ThemeResolver.e(a, InputGroup.ru, InputGroup.qe);
        this.qz = ThemeResolver.e(a, InputGroup.rt, InputGroup.qd);
        this.fc = ThemeResolver.b(a, InputGroup.gc, InputGroup.ej);
        this.fa = ThemeResolver.b(a, InputGroup.ga, InputGroup.eh);
        this.e8 = ThemeResolver.b(a, InputGroup.f8, InputGroup.ef);
        this.e9 = ThemeResolver.b(a, InputGroup.f9, InputGroup.eg);
        this.fd = ThemeResolver.b(a, InputGroup.gd, InputGroup.ek);
        this.qv = ThemeResolver.e(a, InputGroup.rp, InputGroup.p9);
        this.dc = ThemeResolver.b(a, InputGroup.fr, InputGroup.dy);
        this.dd = ThemeResolver.b(a, InputGroup.fs, InputGroup.dz);
        this.mw = ThemeResolver.d(a, InputGroup.m5, InputGroup.mz);
        this.tc = ThemeResolver.f(a, InputGroup.tl, InputGroup.tf);
        this.pg = ThemeResolver.e(a, InputGroup.re, InputGroup.py);
        this.ph = ThemeResolver.e(a, InputGroup.rf, InputGroup.pz);
        this.pi = ThemeResolver.e(a, InputGroup.rg, InputGroup.p0);
        this.dl = ThemeResolver.b(a, InputGroup.f0, InputGroup.d7);
        this.dk = ThemeResolver.b(a, InputGroup.fz, InputGroup.d6);
        this.dh = ThemeResolver.b(a, InputGroup.fw, InputGroup.d3);
        this.pl = ThemeResolver.e(a, InputGroup.rj, InputGroup.p3);
        this.pm = ThemeResolver.e(a, InputGroup.rk, InputGroup.p4);
        this.pk = ThemeResolver.e(a, InputGroup.ri, InputGroup.p2);
        this.pj = ThemeResolver.e(a, InputGroup.rh, InputGroup.p1);
        this.di = ThemeResolver.b(a, InputGroup.fx, InputGroup.d4);
        this.dg = ThemeResolver.b(a, InputGroup.fv, InputGroup.d2);
        this.de = ThemeResolver.b(a, InputGroup.ft, InputGroup.d0);
        this.df = ThemeResolver.b(a, InputGroup.fu, InputGroup.d1);
        this.dj = ThemeResolver.b(a, InputGroup.fy, InputGroup.d5);
        this.pf = ThemeResolver.e(a, InputGroup.rd, InputGroup.px);
        this.c1 = ThemeResolver.b(a, InputGroup.fg, InputGroup.dm);
        this.c2 = ThemeResolver.b(a, InputGroup.fh, InputGroup.dn);
        this.mv = ThemeResolver.d(a, InputGroup.m4, InputGroup.my);
        this.tb = ThemeResolver.f(a, InputGroup.tk, InputGroup.te);
        this.o8 = ThemeResolver.e(a, InputGroup.q6, InputGroup.pq);
        this.o9 = ThemeResolver.e(a, InputGroup.q7, InputGroup.pr);
        this.pa = ThemeResolver.e(a, InputGroup.q8, InputGroup.ps);
        this.da = ThemeResolver.b(a, InputGroup.fp, InputGroup.dw);
        this.c9 = ThemeResolver.b(a, InputGroup.fo, InputGroup.dv);
        this.c6 = ThemeResolver.b(a, InputGroup.fl, InputGroup.ds);
        this.pd = ThemeResolver.e(a, InputGroup.rb, InputGroup.pv);
        this.pe = ThemeResolver.e(a, InputGroup.rc, InputGroup.pw);
        this.pc = ThemeResolver.e(a, InputGroup.ra, InputGroup.pu);
        this.pb = ThemeResolver.e(a, InputGroup.q9, InputGroup.pt);
        this.c7 = ThemeResolver.b(a, InputGroup.fm, InputGroup.dt);
        this.c5 = ThemeResolver.b(a, InputGroup.fk, InputGroup.dr);
        this.c3 = ThemeResolver.b(a, InputGroup.fi, InputGroup.dp);
        this.c4 = ThemeResolver.b(a, InputGroup.fj, InputGroup.dq);
        this.c8 = ThemeResolver.b(a, InputGroup.fn, InputGroup.du);
        this.o7 = ThemeResolver.e(a, InputGroup.q5, InputGroup.pp);
        this.gu = ThemeResolver.b(a, InputGroup.gg, InputGroup.en);
        this.gv = ThemeResolver.b(a, InputGroup.gh, InputGroup.eo);
        this.m9 = ThemeResolver.d(a, InputGroup.m8, InputGroup.m2);
        this.tp = ThemeResolver.f(a, InputGroup.to, InputGroup.ti);
        this.r8 = ThemeResolver.e(a, InputGroup.ry, InputGroup.qi);
        this.r9 = ThemeResolver.e(a, InputGroup.rz, InputGroup.qj);
        this.sa = ThemeResolver.e(a, InputGroup.r0, InputGroup.qk);
        this.g3 = ThemeResolver.b(a, InputGroup.gp, InputGroup.ew);
        this.g2 = ThemeResolver.b(a, InputGroup.go, InputGroup.ev);
        this.gz = ThemeResolver.b(a, InputGroup.gl, InputGroup.es);
        this.sd = ThemeResolver.e(a, InputGroup.r3, InputGroup.qn);
        this.se = ThemeResolver.e(a, InputGroup.r4, InputGroup.qo);
        this.sc = ThemeResolver.e(a, InputGroup.r2, InputGroup.qm);
        this.sb = ThemeResolver.e(a, InputGroup.r1, InputGroup.ql);
        this.g0 = ThemeResolver.b(a, InputGroup.gm, InputGroup.et);
        this.gy = ThemeResolver.b(a, InputGroup.gk, InputGroup.er);
        this.gw = ThemeResolver.b(a, InputGroup.gi, InputGroup.ep);
        this.gx = ThemeResolver.b(a, InputGroup.gj, InputGroup.eq);
        this.g1 = ThemeResolver.b(a, InputGroup.gn, InputGroup.eu);
        this.r7 = ThemeResolver.e(a, InputGroup.rx, InputGroup.qh);
    };
    InputGroup.prototype.ly = function () {
        this.lt();
        if (this.ab) {
            this.lv(function (a) { return a.am = true; });
        }
        else {
            this.lv(function (a) { return a.am = false; });
        }
    };
    InputGroup.prototype.l3 = function () {
        this.lt();
        if (this.af) {
            var a = 1;
            this.lv(function (b) { return b.ak = true; });
            this.l7(a);
        }
        else {
            var b = -1;
            this.lv(function (c) { return c.ak = false; });
            this.l7(b);
        }
    };
    InputGroup.prototype.l2 = function () {
        this.ab = this.s ? this.ae : true;
        this.af = true;
        if (null != this.gotFocus) {
            this.gotFocus(this, EventArgs.empty);
        }
    };
    InputGroup.prototype.mj = function () {
        if (this.s) {
            this.ab = this.s;
        }
        else if (this.af) {
            this.ab = true;
        }
        else {
            this.ab = this.ac ? true : false;
        }
    };
    InputGroup.prototype.l7 = function (a) {
        var _this = this;
        if ((a > 0 && this.p.playbackRate < 0) || (a < 0 && this.p.playbackRate > 0)) {
            this.p.reverse();
            this.p.finished.f(function (b) {
                if (_this.p != null) {
                    _this.p.commitStyles();
                }
                if (_this.aa) {
                    _this.p = null;
                    _this.aa = false;
                }
            });
            this.n.reverse();
            this.n.finished.f(function (b) {
                if (_this.n != null) {
                    _this.n.commitStyles();
                }
                if (_this.r) {
                    _this.n = null;
                    _this.r = false;
                }
            });
            this.o.reverse();
            this.o.finished.f(function (b) {
                if (_this.o != null) {
                    _this.o.commitStyles();
                }
                if (_this.z) {
                    _this.o = null;
                    _this.z = false;
                }
            });
        }
        else {
            this.p.play();
            this.p.finished.f(function (b) {
                if (_this.p != null) {
                    _this.p.commitStyles();
                }
                if (_this.aa) {
                    _this.p = null;
                    _this.aa = false;
                }
            });
            this.n.play();
            this.n.finished.f(function (b) {
                if (_this.n != null) {
                    _this.n.commitStyles();
                }
                if (_this.r) {
                    _this.n = null;
                    _this.r = false;
                }
            });
            this.o.play();
            this.o.finished.f(function (b) {
                if (_this.o != null) {
                    _this.o.commitStyles();
                }
                if (_this.z) {
                    _this.o = null;
                    _this.z = false;
                }
            });
        }
    };
    Object.defineProperty(InputGroup.prototype, "oj", {
        get: function () {
            return this.nd;
        },
        set: function (a) {
            var b = this.nd;
            this.nd = a;
            if (b != this.nd) {
                this.l5("ActualBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ok", {
        get: function () {
            return this.ne;
        },
        set: function (a) {
            var b = this.ne;
            this.ne = a;
            if (b != this.ne) {
                this.l5("ActualFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "b6", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (b != this.ai) {
                this.l5("ActualBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "b7", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            var b = this.aj;
            this.aj = a;
            if (b != this.aj) {
                this.l5("ActualFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "mq", {
        get: function () {
            return this.mk;
        },
        set: function (a) {
            var b = this.mk;
            this.mk = a;
            if (b != this.mk) {
                this.l5("ActualCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s6", {
        get: function () {
            return this.s0;
        },
        set: function (a) {
            var b = this.s0;
            this.s0 = a;
            if (b != this.s0) {
                this.l5("ActualContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cf", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            if (b != this.ar) {
                this.l5("ActualUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ce", {
        get: function () {
            return this.aq;
        },
        set: function (a) {
            var b = this.aq;
            this.aq = a;
            if (b != this.aq) {
                this.l5("ActualUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cb", {
        get: function () {
            return this.an;
        },
        set: function (a) {
            var b = this.an;
            this.an = a;
            if (b != this.an) {
                this.l5("ActualHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "on", {
        get: function () {
            return this.nh;
        },
        set: function (a) {
            var b = this.nh;
            this.nh = a;
            if (b != this.nh) {
                this.l5("ActualUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "oo", {
        get: function () {
            return this.ni;
        },
        set: function (a) {
            var b = this.ni;
            this.ni = a;
            if (b != this.ni) {
                this.l5("ActualUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "om", {
        get: function () {
            return this.ng;
        },
        set: function (a) {
            var b = this.ng;
            this.ng = a;
            if (b != this.ng) {
                this.l5("ActualHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ol", {
        get: function () {
            return this.nf;
        },
        set: function (a) {
            var b = this.nf;
            this.n0 = a;
            if (b != this.nf) {
                this.l5("ActualFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cc", {
        get: function () {
            return this.ao;
        },
        set: function (a) {
            var b = this.ao;
            this.ao = a;
            if (b != this.ao) {
                this.l5("ActualUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ca", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (b != this.am) {
                this.l5("ActualHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "b8", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            if (b != this.ak) {
                this.l5("ActualFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "b9", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (b != this.al) {
                this.l5("ActualFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cd", {
        get: function () {
            return this.ap;
        },
        set: function (a) {
            var b = this.ap;
            this.ap = a;
            if (b != this.ap) {
                this.l5("ActualUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "oi", {
        get: function () {
            return this.nc;
        },
        set: function (a) {
            var b = this.nc;
            this.nc = a;
            if (b != this.nc) {
                this.l5("ActualBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cq", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (b != this.a2) {
                this.l5("BorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "g8", {
        get: function () {
            return this.bd;
        },
        set: function (a) {
            var b = this.bd;
            this.bd = a;
            if (b != this.bd) {
                this.l5("FocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "oq", {
        get: function () {
            return this.nk;
        },
        set: function (a) {
            var b = this.nk;
            this.nk = a;
            if (b != this.nk) {
                this.l5("BorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "mu", {
        get: function () {
            return this.mn;
        },
        set: function (a) {
            var b = this.mn;
            this.mn = a;
            if (b != this.mn) {
                this.l5("CornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ta", {
        get: function () {
            return this.s3;
        },
        set: function (a) {
            var b = this.s3;
            this.s3 = a;
            if (b != this.s3) {
                this.l5("ContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h0", {
        get: function () {
            return this.b5;
        },
        set: function (a) {
            var b = this.b5;
            this.b5 = a;
            if (b != this.b5) {
                this.l5("UnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hz", {
        get: function () {
            return this.b4;
        },
        set: function (a) {
            var b = this.b4;
            this.b4 = a;
            if (b != this.b4) {
                this.l5("UnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hc", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.l5("HoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sy", {
        get: function () {
            return this.og;
        },
        set: function (a) {
            var b = this.og;
            this.og = a;
            if (b != this.og) {
                this.l5("UnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sz", {
        get: function () {
            return this.oh;
        },
        set: function (a) {
            var b = this.oh;
            this.oh = a;
            if (b != this.oh) {
                this.l5("UnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sj", {
        get: function () {
            return this.n1;
        },
        set: function (a) {
            var b = this.n1;
            this.n1 = a;
            if (b != this.n1) {
                this.l5("HoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "si", {
        get: function () {
            return this.n0;
        },
        set: function (a) {
            var b = this.n0;
            this.n0 = a;
            if (b != this.n0) {
                this.l5("FocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hx", {
        get: function () {
            return this.b2;
        },
        set: function (a) {
            var b = this.b2;
            this.b2 = a;
            if (b != this.b2) {
                this.l5("UnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hb", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (b != this.bg) {
                this.l5("HoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "g9", {
        get: function () {
            return this.be;
        },
        set: function (a) {
            var b = this.be;
            this.be = a;
            if (b != this.be) {
                this.l5("FocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ha", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (b != this.bf) {
                this.l5("FocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hy", {
        get: function () {
            return this.b3;
        },
        set: function (a) {
            var b = this.b3;
            this.b3 = a;
            if (b != this.b3) {
                this.l5("UnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "op", {
        get: function () {
            return this.nj;
        },
        set: function (a) {
            var b = this.nj;
            this.nj = a;
            if (b != this.nj) {
                this.l5("BackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hd", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.l5("LineTypeBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "he", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (b != this.bj) {
                this.l5("LineTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sm", {
        get: function () {
            return this.n4;
        },
        set: function (a) {
            var b = this.n4;
            this.n4 = a;
            if (b != this.n4) {
                this.l5("LineTypeFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sl", {
        get: function () {
            return this.n3;
        },
        set: function (a) {
            var b = this.n3;
            this.n3 = a;
            if (b != this.n3) {
                this.l5("LineTypeBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "na", {
        get: function () {
            return this.mo;
        },
        set: function (a) {
            var b = this.mo;
            this.mo = a;
            if (b != this.mo) {
                this.l5("LineTypeCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "tq", {
        get: function () {
            return this.s4;
        },
        set: function (a) {
            var b = this.s4;
            this.s4 = a;
            if (b != this.s4) {
                this.l5("LineTypeContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hm", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            var b = this.br;
            this.br = a;
            if (b != this.br) {
                this.l5("LineTypeUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hl", {
        get: function () {
            return this.bq;
        },
        set: function (a) {
            var b = this.bq;
            this.bq = a;
            if (b != this.bq) {
                this.l5("LineTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hi", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (b != this.bn) {
                this.l5("LineTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sp", {
        get: function () {
            return this.n7;
        },
        set: function (a) {
            var b = this.n7;
            this.n7 = a;
            if (b != this.n7) {
                this.l5("LineTypeUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sq", {
        get: function () {
            return this.n8;
        },
        set: function (a) {
            var b = this.n8;
            this.n8 = a;
            if (b != this.n8) {
                this.l5("LineTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "so", {
        get: function () {
            return this.n6;
        },
        set: function (a) {
            var b = this.n6;
            this.n1 = a;
            if (b != this.n6) {
                this.l5("LineTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sn", {
        get: function () {
            return this.n5;
        },
        set: function (a) {
            var b = this.n5;
            this.n5 = a;
            if (b != this.n5) {
                this.l5("LineTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hj", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            if (b != this.bo) {
                this.l5("LineTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hh", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (b != this.bm) {
                this.l5("LineTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hf", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.l5("LineTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hg", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (b != this.bl) {
                this.l5("LineTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hk", {
        get: function () {
            return this.bp;
        },
        set: function (a) {
            var b = this.bp;
            this.bp = a;
            if (b != this.bp) {
                this.l5("LineTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sk", {
        get: function () {
            return this.n2;
        },
        set: function (a) {
            var b = this.n2;
            this.n2 = a;
            if (b != this.n2) {
                this.l5("LineTypeBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cr", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            if (b != this.a3) {
                this.l5("BoxTypeBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cs", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            if (b != this.a4) {
                this.l5("BoxTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o0", {
        get: function () {
            return this.nu;
        },
        set: function (a) {
            var b = this.nu;
            this.nu = a;
            if (b != this.nu) {
                this.l5("BoxTypeFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "oz", {
        get: function () {
            return this.nt;
        },
        set: function (a) {
            var b = this.nt;
            this.nt = a;
            if (b != this.nt) {
                this.l5("BoxTypeBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ms", {
        get: function () {
            return this.mm;
        },
        set: function (a) {
            var b = this.mm;
            this.mm = a;
            if (b != this.mm) {
                this.l5("BoxTypeCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s8", {
        get: function () {
            return this.s2;
        },
        set: function (a) {
            var b = this.s2;
            this.s2 = a;
            if (b != this.s2) {
                this.l5("BoxTypeContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "c0", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            var b = this.bc;
            this.bc = a;
            if (b != this.bc) {
                this.l5("BoxTypeUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cz", {
        get: function () {
            return this.bb;
        },
        set: function (a) {
            var b = this.bb;
            this.bb = a;
            if (b != this.bb) {
                this.l5("BoxTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cw", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (b != this.a8) {
                this.l5("BoxTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o3", {
        get: function () {
            return this.nx;
        },
        set: function (a) {
            var b = this.nx;
            this.nx = a;
            if (b != this.nx) {
                this.l5("BoxTypeUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o4", {
        get: function () {
            return this.ny;
        },
        set: function (a) {
            var b = this.ny;
            this.ny = a;
            if (b != this.ny) {
                this.l5("BoxTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o2", {
        get: function () {
            return this.nw;
        },
        set: function (a) {
            var b = this.nw;
            this.n1 = a;
            if (b != this.nw) {
                this.l5("BoxTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o1", {
        get: function () {
            return this.nv;
        },
        set: function (a) {
            var b = this.nv;
            this.nv = a;
            if (b != this.nv) {
                this.l5("BoxTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cx", {
        get: function () {
            return this.a9;
        },
        set: function (a) {
            var b = this.a9;
            this.a9 = a;
            if (b != this.a9) {
                this.l5("BoxTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cv", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (b != this.a7) {
                this.l5("BoxTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ct", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            if (b != this.a5) {
                this.l5("BoxTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cu", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (b != this.a6) {
                this.l5("BoxTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cy", {
        get: function () {
            return this.ba;
        },
        set: function (a) {
            var b = this.ba;
            this.ba = a;
            if (b != this.ba) {
                this.l5("BoxTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "oy", {
        get: function () {
            return this.ns;
        },
        set: function (a) {
            var b = this.ns;
            this.ns = a;
            if (b != this.ns) {
                this.l5("BoxTypeBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cg", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            this.as = a;
            if (b != this.as) {
                this.l5("BorderTypeBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ch", {
        get: function () {
            return this.at;
        },
        set: function (a) {
            var b = this.at;
            this.at = a;
            if (b != this.at) {
                this.l5("BorderTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ot", {
        get: function () {
            return this.nn;
        },
        set: function (a) {
            var b = this.nn;
            this.nn = a;
            if (b != this.nn) {
                this.l5("BorderTypeFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "os", {
        get: function () {
            return this.nm;
        },
        set: function (a) {
            var b = this.nm;
            this.nm = a;
            if (b != this.nm) {
                this.l5("BorderTypeBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "mr", {
        get: function () {
            return this.ml;
        },
        set: function (a) {
            var b = this.ml;
            this.ml = a;
            if (b != this.ml) {
                this.l5("BorderTypeCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s7", {
        get: function () {
            return this.s1;
        },
        set: function (a) {
            var b = this.s1;
            this.s1 = a;
            if (b != this.s1) {
                this.l5("BorderTypeContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cp", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            var b = this.a1;
            this.a1 = a;
            if (b != this.a1) {
                this.l5("BorderTypeUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "co", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            var b = this.a0;
            this.a0 = a;
            if (b != this.a0) {
                this.l5("BorderTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cl", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            if (b != this.ax) {
                this.l5("BorderTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ow", {
        get: function () {
            return this.nq;
        },
        set: function (a) {
            var b = this.nq;
            this.nq = a;
            if (b != this.nq) {
                this.l5("BorderTypeUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ox", {
        get: function () {
            return this.nr;
        },
        set: function (a) {
            var b = this.nr;
            this.nr = a;
            if (b != this.nr) {
                this.l5("BorderTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ov", {
        get: function () {
            return this.np;
        },
        set: function (a) {
            var b = this.np;
            this.n1 = a;
            if (b != this.np) {
                this.l5("BorderTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ou", {
        get: function () {
            return this.no;
        },
        set: function (a) {
            var b = this.no;
            this.no = a;
            if (b != this.no) {
                this.l5("BorderTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cm", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (b != this.ay) {
                this.l5("BorderTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ck", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (b != this.aw) {
                this.l5("BorderTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ci", {
        get: function () {
            return this.au;
        },
        set: function (a) {
            var b = this.au;
            this.au = a;
            if (b != this.au) {
                this.l5("BorderTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cj", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            if (b != this.av) {
                this.l5("BorderTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cn", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.az = a;
            if (b != this.az) {
                this.l5("BorderTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "or", {
        get: function () {
            return this.nl;
        },
        set: function (a) {
            var b = this.nl;
            this.nl = a;
            if (b != this.nl) {
                this.l5("BorderTypeBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hn", {
        get: function () {
            return this.bs;
        },
        set: function (a) {
            var b = this.bs;
            this.bs = a;
            if (b != this.bs) {
                this.l5("SearchTypeBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ho", {
        get: function () {
            return this.bt;
        },
        set: function (a) {
            var b = this.bt;
            this.bt = a;
            if (b != this.bt) {
                this.l5("SearchTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "st", {
        get: function () {
            return this.ob;
        },
        set: function (a) {
            var b = this.ob;
            this.ob = a;
            if (b != this.ob) {
                this.l5("SearchTypeFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ss", {
        get: function () {
            return this.oa;
        },
        set: function (a) {
            var b = this.oa;
            this.oa = a;
            if (b != this.oa) {
                this.l5("SearchTypeBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "nb", {
        get: function () {
            return this.mp;
        },
        set: function (a) {
            var b = this.mp;
            this.mp = a;
            if (b != this.mp) {
                this.l5("SearchTypeCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "tr", {
        get: function () {
            return this.s5;
        },
        set: function (a) {
            var b = this.s5;
            this.s5 = a;
            if (b != this.s5) {
                this.l5("SearchTypeContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hw", {
        get: function () {
            return this.b1;
        },
        set: function (a) {
            var b = this.b1;
            this.b1 = a;
            if (b != this.b1) {
                this.l5("SearchTypeUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hv", {
        get: function () {
            return this.b0;
        },
        set: function (a) {
            var b = this.b0;
            this.b0 = a;
            if (b != this.b0) {
                this.l5("SearchTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hs", {
        get: function () {
            return this.bx;
        },
        set: function (a) {
            var b = this.bx;
            this.bx = a;
            if (b != this.bx) {
                this.l5("SearchTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sw", {
        get: function () {
            return this.oe;
        },
        set: function (a) {
            var b = this.oe;
            this.oe = a;
            if (b != this.oe) {
                this.l5("SearchTypeUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sx", {
        get: function () {
            return this.of;
        },
        set: function (a) {
            var b = this.of;
            this.of = a;
            if (b != this.of) {
                this.l5("SearchTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sv", {
        get: function () {
            return this.od;
        },
        set: function (a) {
            var b = this.od;
            this.n1 = a;
            if (b != this.od) {
                this.l5("SearchTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "su", {
        get: function () {
            return this.oc;
        },
        set: function (a) {
            var b = this.oc;
            this.oc = a;
            if (b != this.oc) {
                this.l5("SearchTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ht", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            var b = this.by;
            this.by = a;
            if (b != this.by) {
                this.l5("SearchTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hr", {
        get: function () {
            return this.bw;
        },
        set: function (a) {
            var b = this.bw;
            this.bw = a;
            if (b != this.bw) {
                this.l5("SearchTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hp", {
        get: function () {
            return this.bu;
        },
        set: function (a) {
            var b = this.bu;
            this.bu = a;
            if (b != this.bu) {
                this.l5("SearchTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hq", {
        get: function () {
            return this.bv;
        },
        set: function (a) {
            var b = this.bv;
            this.bv = a;
            if (b != this.bv) {
                this.l5("SearchTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hu", {
        get: function () {
            return this.bz;
        },
        set: function (a) {
            var b = this.bz;
            this.bz = a;
            if (b != this.bz) {
                this.l5("SearchTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sr", {
        get: function () {
            return this.n9;
        },
        set: function (a) {
            var b = this.n9;
            this.n9 = a;
            if (b != this.n9) {
                this.l5("SearchTypeBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ae", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (b != this.w) {
                this.l5("IsExpanded", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.mb = function () {
        this.w = false;
        this.s = false;
        this.mj();
    };
    Object.defineProperty(InputGroup.prototype, "ag", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (b != this.y) {
                this.l5("IsHovered", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "af", {
        get: function () {
            return this.x;
        },
        set: function (a) {
            var b = this.x;
            this.x = a;
            if (b != this.x) {
                this.l5("IsFocused", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ab", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            if (b != this.q) {
                this.l5("ActualIsExpanded", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sh", {
        get: function () {
            return this.nz;
        },
        set: function (a) {
            var b = this.nz;
            this.nz = a;
            if (b != this.nz) {
                this.l5("FocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ka", {
        get: function () {
            return this.h4;
        },
        set: function (a) {
            var b = this.h4;
            this.h4 = a;
            if (b != this.h4) {
                this.l5("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "disabled", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.l5("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.l6 = function () {
    };
    InputGroup.prototype.onDetachedFromUI = function () {
        this.view.ae();
    };
    InputGroup.prototype.onAttachedToUI = function () {
        this.view.ac();
    };
    InputGroup.prototype.ah = function () {
        return this.view.g();
    };
    InputGroup.prototype.provideContainer = function (a) {
        this.view.ad(a);
    };
    Object.defineProperty(InputGroup.prototype, "inputs", {
        get: function () {
            return this.k;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.$t = markType(InputGroup, 'InputGroup', Base.$, [INotifyPropertyChanged_$type]);
    InputGroup.c = 2;
    InputGroup.fq = 0;
    InputGroup.f1 = 0;
    InputGroup.m6 = new CornerRadius(1, 0, 0, 0, 0);
    InputGroup.tm = new Thickness(1, 0, 0, 0, 0);
    InputGroup.q4 = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rl = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rm = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gt = 1;
    InputGroup.gs = 2;
    InputGroup.f5 = 2;
    InputGroup.r5 = BrushUtil.g(138, 0, 0, 0);
    InputGroup.r6 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.ro = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rn = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gq = 1;
    InputGroup.f4 = 1;
    InputGroup.f2 = 1;
    InputGroup.f3 = 1;
    InputGroup.gr = 0;
    InputGroup.q3 = BrushUtil.g(0, 0, 0, 0);
    InputGroup.f6 = 0;
    InputGroup.f7 = 0;
    InputGroup.m7 = new CornerRadius(1, 0, 0, 0, 0);
    InputGroup.tn = new Thickness(1, 0, 0, 0, 0);
    InputGroup.rq = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rr = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rs = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gf = 1;
    InputGroup.ge = 2;
    InputGroup.gb = 2;
    InputGroup.rv = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rw = BrushUtil.g(255, 0, 153, 155);
    InputGroup.ru = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rt = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gc = 1;
    InputGroup.ga = 1;
    InputGroup.f8 = 1;
    InputGroup.f9 = 1;
    InputGroup.gd = 0;
    InputGroup.rp = BrushUtil.g(0, 0, 0, 0);
    InputGroup.fr = 0;
    InputGroup.fs = 0;
    InputGroup.m5 = new CornerRadius(1, 4, 4, 0, 0);
    InputGroup.tl = new Thickness(1, 16, 0, 16, 0);
    InputGroup.re = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rf = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rg = BrushUtil.g(255, 0, 153, 155);
    InputGroup.f0 = 1;
    InputGroup.fz = 2;
    InputGroup.fw = 2;
    InputGroup.rj = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rk = BrushUtil.g(255, 0, 153, 155);
    InputGroup.ri = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rh = BrushUtil.g(255, 0, 153, 155);
    InputGroup.fx = 1;
    InputGroup.fv = 1;
    InputGroup.ft = 1;
    InputGroup.fu = 1;
    InputGroup.fy = 0;
    InputGroup.rd = BrushUtil.g(20, 0, 0, 0);
    InputGroup.fg = 1;
    InputGroup.fh = 2;
    InputGroup.m4 = new CornerRadius(1, 4, 4, 4, 4);
    InputGroup.tk = new Thickness(1, 16, 0, 16, 0);
    InputGroup.q6 = BrushUtil.g(138, 0, 0, 0);
    InputGroup.q7 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.q8 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.fp = 1;
    InputGroup.fo = 2;
    InputGroup.fl = 2;
    InputGroup.rb = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rc = BrushUtil.g(255, 0, 153, 155);
    InputGroup.ra = BrushUtil.g(138, 0, 0, 0);
    InputGroup.q9 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.fm = 0;
    InputGroup.fk = 0;
    InputGroup.fi = 0;
    InputGroup.fj = 0;
    InputGroup.fn = 0;
    InputGroup.q5 = BrushUtil.g(0, 0, 0, 0);
    InputGroup.gg = 1;
    InputGroup.gh = 2;
    InputGroup.m8 = new CornerRadius(1, 4, 4, 4, 4);
    InputGroup.to = new Thickness(1, 16, 0, 16, 0);
    InputGroup.ry = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rz = BrushUtil.g(255, 0, 153, 155);
    InputGroup.r0 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gp = 1;
    InputGroup.go = 2;
    InputGroup.gl = 2;
    InputGroup.r3 = BrushUtil.g(138, 0, 0, 0);
    InputGroup.r4 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.r2 = BrushUtil.g(138, 0, 0, 0);
    InputGroup.r1 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gm = 0;
    InputGroup.gk = 0;
    InputGroup.gi = 0;
    InputGroup.gj = 0;
    InputGroup.gn = 0;
    InputGroup.rx = BrushUtil.g(0, 0, 0, 0);
    InputGroup.dx = 0;
    InputGroup.d8 = 0;
    InputGroup.m0 = new CornerRadius(1, 0, 0, 0, 0);
    InputGroup.tg = new Thickness(1, 0, 0, 0, 0);
    InputGroup.po = BrushUtil.g(255, 186, 191, 199);
    InputGroup.p5 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.p6 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.e0 = 1;
    InputGroup.ez = 2;
    InputGroup.ec = 2;
    InputGroup.qp = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qq = BrushUtil.g(255, 33, 150, 243);
    InputGroup.p8 = BrushUtil.g(255, 186, 191, 199);
    InputGroup.p7 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.ex = 1;
    InputGroup.eb = 1;
    InputGroup.d9 = 1;
    InputGroup.ea = 1;
    InputGroup.ey = 0;
    InputGroup.pn = BrushUtil.g(0, 0, 0, 0);
    InputGroup.ed = 0;
    InputGroup.ee = 0;
    InputGroup.m1 = new CornerRadius(1, 0, 0, 0, 0);
    InputGroup.th = new Thickness(1, 0, 0, 0, 0);
    InputGroup.qa = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qb = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qc = BrushUtil.g(255, 33, 150, 243);
    InputGroup.em = 1;
    InputGroup.el = 2;
    InputGroup.ei = 2;
    InputGroup.qf = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qg = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qe = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qd = BrushUtil.g(255, 33, 150, 243);
    InputGroup.ej = 1;
    InputGroup.eh = 1;
    InputGroup.ef = 1;
    InputGroup.eg = 1;
    InputGroup.ek = 0;
    InputGroup.p9 = BrushUtil.g(0, 0, 0, 0);
    InputGroup.dy = 0;
    InputGroup.dz = 0;
    InputGroup.mz = new CornerRadius(1, 4, 4, 0, 0);
    InputGroup.tf = new Thickness(1, 16, 0, 16, 0);
    InputGroup.py = BrushUtil.g(255, 186, 191, 199);
    InputGroup.pz = BrushUtil.g(255, 33, 150, 243);
    InputGroup.p0 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.d7 = 1;
    InputGroup.d6 = 2;
    InputGroup.d3 = 2;
    InputGroup.p3 = BrushUtil.g(255, 186, 191, 199);
    InputGroup.p4 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.p2 = BrushUtil.g(255, 186, 191, 199);
    InputGroup.p1 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.d4 = 1;
    InputGroup.d2 = 1;
    InputGroup.d0 = 1;
    InputGroup.d1 = 1;
    InputGroup.d5 = 0;
    InputGroup.px = BrushUtil.g(20, 0, 0, 0);
    InputGroup.dm = 1;
    InputGroup.dn = 2;
    InputGroup.my = new CornerRadius(1, 4, 4, 4, 4);
    InputGroup.te = new Thickness(1, 16, 0, 16, 0);
    InputGroup.pq = BrushUtil.g(255, 186, 191, 199);
    InputGroup.pr = BrushUtil.g(255, 33, 150, 243);
    InputGroup.ps = BrushUtil.g(255, 33, 150, 243);
    InputGroup.dw = 1;
    InputGroup.dv = 2;
    InputGroup.ds = 2;
    InputGroup.pv = BrushUtil.g(255, 186, 191, 199);
    InputGroup.pw = BrushUtil.g(255, 33, 150, 243);
    InputGroup.pu = BrushUtil.g(255, 186, 191, 199);
    InputGroup.pt = BrushUtil.g(255, 33, 150, 243);
    InputGroup.dt = 0;
    InputGroup.dr = 0;
    InputGroup.dp = 0;
    InputGroup.dq = 0;
    InputGroup.du = 0;
    InputGroup.pp = BrushUtil.g(0, 0, 0, 0);
    InputGroup.en = 1;
    InputGroup.eo = 2;
    InputGroup.m2 = new CornerRadius(1, 4, 4, 4, 4);
    InputGroup.ti = new Thickness(1, 16, 0, 16, 0);
    InputGroup.qi = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qj = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qk = BrushUtil.g(255, 33, 150, 243);
    InputGroup.ew = 1;
    InputGroup.ev = 2;
    InputGroup.es = 2;
    InputGroup.qn = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qo = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qm = BrushUtil.g(255, 186, 191, 199);
    InputGroup.ql = BrushUtil.g(255, 33, 150, 243);
    InputGroup.et = 0;
    InputGroup.er = 0;
    InputGroup.ep = 0;
    InputGroup.eq = 0;
    InputGroup.eu = 0;
    InputGroup.qh = BrushUtil.g(0, 0, 0, 0);
    InputGroup.h3 = 0;
    return InputGroup;
}(Base));
export { InputGroup };
/**
 * @hidden
 */
var InputGroupInputCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputGroupInputCollection, _super);
    function InputGroupInputCollection() {
        var _this = _super.call(this, InputGroupItem.$, 0) || this;
        _this.collectionResetting = null;
        return _this;
    }
    InputGroupInputCollection.prototype.p = function () {
        if (this.collectionResetting != null) {
            this.collectionResetting(this, null);
        }
        _super.prototype.p.call(this);
    };
    InputGroupInputCollection.$t = markType(InputGroupInputCollection, 'InputGroupInputCollection', ObservableCollection$1.$.specialize(InputGroupItem.$));
    return InputGroupInputCollection;
}(ObservableCollection$1));
export { InputGroupInputCollection };
/**
 * @hidden
 */
var Label = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        var _this = _super.call(this) || this;
        _this.j = 0;
        _this._view = null;
        _this.z = null;
        _this.y = null;
        _this.n = 0;
        _this.m = 1;
        _this.ci = ThemeResolver.e(Label.k, Label.c1, Label.cu);
        _this.cf = ThemeResolver.e(Label.k, Label.cy, Label.cr);
        _this.cg = ThemeResolver.e(Label.k, Label.cz, Label.cs);
        _this.ch = ThemeResolver.e(Label.k, Label.c0, Label.ct);
        _this.t = null;
        _this.cm = Label.c2;
        _this.cj = Label.cv;
        _this.ck = Label.cw;
        _this.q = 0;
        _this.ae = false;
        _this.ac = false;
        _this.u = null;
        _this.cl = null;
        _this.ay = "ig-label-" + Label.ar++;
        _this.au = "inline-block";
        _this.av = "inline-block";
        _this.aw = null;
        _this.as = "center";
        _this.ap = 0;
        _this.aa = false;
        _this.ax = null;
        _this.at = null;
        _this.az = null;
        _this.ad = false;
        _this.ah = false;
        _this.ab = false;
        _this.ag = false;
        _this.af = false;
        var a = new LabelView();
        a.b = _this;
        _this.view = a;
        _this.view.y();
        return _this;
    }
    Object.defineProperty(Label.prototype, "l", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(Label.prototype, "i", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.b1 = function () {
        var _this = this;
        this.view.q();
        var a = false;
        if (this.z == null) {
            var b = new TransformGroup();
            b.j.add(((function () {
                var $ret = new TranslateTransform();
                $ret.k = _this.r == 0 ? (_this.view.h() * 0.5) : 0;
                return $ret;
            })()));
            b.j.add(((function () {
                var $ret = new ScaleTransform();
                $ret.l = 1;
                $ret.m = 1;
                return $ret;
            })()));
            var c_1 = -(this.view.h() * 1.3);
            if (this.o == 2) {
                c_1 = -(this.view.h() * 1.05);
            }
            if (this.o == 3) {
                c_1 = -(this.view.h() * 1.01);
            }
            var d = new TransformGroup();
            d.j.add(((function () {
                var $ret = new TranslateTransform();
                $ret.k = _this.r == 2 ? c_1 : -(_this.view.h() * 0.5);
                return $ret;
            })()));
            d.j.add(((function () {
                var $ret = new ScaleTransform();
                $ret.l = 0.75;
                $ret.m = 0.75;
                return $ret;
            })()));
            this.z = KeyFrameAnimationFactory.f.c(this.view.a(this.i).m(new AnimationKeyFrameProperty(14, b), new AnimationKeyFrameProperty(2, BrushUtil.g(0, 255, 255, 255))).m(new AnimationKeyFrameProperty(14, d), new AnimationKeyFrameProperty(2, BrushUtil.g(this.r == 2 ? 255 : 0, 255, 255, 255))));
        }
        if (this.y == null) {
            this.y = KeyFrameAnimationFactory.f.c(this.view.a(this.i).m(new AnimationKeyFrameProperty(7, this.cq)).m(new AnimationKeyFrameProperty(7, this.cn)));
        }
    };
    Label.prototype.ca = function (a, b) {
        var _this = this;
        if ((b > 0 && a.playbackRate < 0) || (b < 0 && a.playbackRate > 0)) {
            a.reverse();
            a.finished.f(function (c) {
                a.commitStyles();
                if (a == _this.z && _this.ag) {
                    _this.z = null;
                }
                if (a == _this.y && _this.af) {
                    _this.y = null;
                }
            });
        }
        else {
            a.play();
            a.finished.f(function (c) {
                a.commitStyles();
                if (a == _this.z && _this.ag) {
                    _this.z = null;
                }
                if (a == _this.y && _this.af) {
                    _this.y = null;
                }
            });
        }
    };
    Label.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "BaseTheme":
                this.cc(this.l);
                this.ce();
                break;
            case "TextColor":
            case "HoverTextColor":
            case "TextStyle":
            case "HighlightTextColor":
            case "HoverHighlightTextColor":
                this.ce();
                break;
            case "ActualTextColor":
            case "ActualHoverTextColor":
            case "ActualTextStyle":
            case "ActualHighlightTextColor":
            case "ActualHoverHighlightTextColor":
                if (this.z != null) {
                    if (this.z.playState == 3) {
                        this.z = null;
                    }
                    else {
                        this.ag = true;
                    }
                }
                if (this.y != null) {
                    if (this.y.playState == 3) {
                        this.y = null;
                    }
                    else {
                        this.af = true;
                    }
                }
                this.cd();
                break;
            case "Text":
                this.view.ab();
                break;
            case "Density":
                this.o = this.p == 0 ? 1 : this.p;
                break;
            case "ActualDensity":
                this.view.ad();
                this.view.ac();
                break;
            case "InputGroup":
                this.view.ac();
                break;
            case "IsHighlighted":
                this.b4();
                break;
            case "IsShifted":
                this.b5();
                break;
            case "ShiftType":
                if (this.z != null) {
                    if (this.z.playState == 3) {
                        this.z = null;
                    }
                    else {
                        this.ag = true;
                    }
                }
                this.b8();
                break;
            case "Display":
                this.view.v();
                break;
            case "FlexDirection":
                this.view.w();
                break;
            case "FlexGrow":
                this.view.x();
                break;
            case "AlignItems":
                this.view.r();
                break;
        }
    };
    Label.prototype.b8 = function () {
        this.view.ac();
    };
    Label.prototype.b5 = function () {
        this.b1();
        var a = 1;
        var b = this.am;
        if (!b) {
            a = -1;
        }
        this.ca(this.z, a);
    };
    Label.prototype.b4 = function () {
        this.b1();
        var a = 1;
        var b = this.ak;
        if (!b) {
            a = -1;
        }
        this.ca(this.y, a);
    };
    Label.prototype.ce = function () {
        this.cq = this.c6 != null ? this.c6 : Label.c2;
        this.cp = this.c5 != null ? this.c5 : Label.c2;
        this.cn = this.c3 != null ? this.c3 : Label.cv;
        this.v = this.x != null ? this.x : Label.w;
    };
    Label.prototype.cd = function () {
        if (this.v != null) {
            this.view.af(this.v);
        }
        this.view.aa(this.cq);
    };
    Label.prototype.cc = function (a) {
        Label.c2 = ThemeResolver.e(a, Label.c1, Label.cu);
        Label.cv = ThemeResolver.e(a, Label.cy, Label.cr);
        Label.cx = ThemeResolver.e(a, Label.c0, Label.ct);
        Label.cw = ThemeResolver.e(a, Label.cz, Label.cs);
    };
    Object.defineProperty(Label.prototype, "p", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.g("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "o", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "cq", {
        get: function () {
            return this.ci;
        },
        set: function (a) {
            var b = this.ci;
            this.ci = a;
            if (b != this.ci) {
                this.g("ActualTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "cn", {
        get: function () {
            return this.cf;
        },
        set: function (a) {
            var b = this.cf;
            this.cf = a;
            if (b != this.cf) {
                this.g("ActualHighlightTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "co", {
        get: function () {
            return this.cg;
        },
        set: function (a) {
            var b = this.cg;
            this.cg = a;
            if (b != this.cg) {
                this.g("ActualHoverHighlightTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "cp", {
        get: function () {
            return this.ch;
        },
        set: function (a) {
            var b = this.ch;
            this.ch = a;
            if (b != this.ch) {
                this.g("ActualHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "v", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            var b = this.t;
            this.t = a;
            if (b != this.t) {
                this.g("ActualTextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "c6", {
        get: function () {
            return this.cm;
        },
        set: function (a) {
            var b = this.cm;
            this.cm = a;
            if (b != this.cm) {
                this.g("TextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "c3", {
        get: function () {
            return this.cj;
        },
        set: function (a) {
            var b = this.cj;
            this.cj = a;
            if (b != this.cj) {
                this.g("HighlightTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "c4", {
        get: function () {
            return this.ck;
        },
        set: function (a) {
            var b = this.ck;
            this.ck = a;
            if (b != this.ck) {
                this.g("HoverHighlightTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "r", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            if (b != this.q) {
                this.g("ShiftType", enumGetBox(LabelShiftType_$type, b), enumGetBox(LabelShiftType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "am", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            var b = this.ae;
            this.ae = a;
            if (b != this.ae) {
                this.g("IsShifted", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "ak", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (b != this.ac) {
                this.g("IsHighlighted", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.b6 = function () {
        this.al = true;
    };
    Label.prototype.b7 = function () {
        this.al = false;
    };
    Object.defineProperty(Label.prototype, "x", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (b != this.u) {
                this.g("TextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "c5", {
        get: function () {
            return this.cl;
        },
        set: function (a) {
            var b = this.cl;
            this.cl = a;
            if (b != this.cl) {
                this.g("HoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bn", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (b != this.ay) {
                this.g("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bc", {
        get: function () {
            return this.au;
        },
        set: function (a) {
            var b = this.au;
            this.au = a;
            if (b != this.au) {
                this.g("Display", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "be", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            if (b != this.av) {
                this.g("FlexDirection", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bg", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (b != this.aw) {
                this.g("FlexGrow", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "a6", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            this.as = a;
            if (b != this.as) {
                this.g("AlignItems", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "ai", {
        get: function () {
            return this.aa;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "aq", {
        get: function () {
            return this.ap;
        },
        set: function (a) {
            var b = this.ap;
            this.ap = a;
            this.aa = true;
            if (b != this.ap) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bi", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            if (b != this.ax) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "a8", {
        get: function () {
            return this.at;
        },
        set: function (a) {
            var b = this.at;
            this.at = a;
            if (b != this.at) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "text", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.az = a;
            if (b != this.az) {
                this.g("Text", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "al", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            var b = this.ad;
            this.ad = a;
            if (b != this.ad) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "ao", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            var b = this.ah;
            this.ah = a;
            if (b != this.ah) {
                this.g("Value", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "disabled", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (b != this.ab) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.b9 = function () {
        this.view.ab();
    };
    Label.prototype.onDetachedFromUI = function () {
        this.view.u();
    };
    Label.prototype.onAttachedToUI = function () {
        this.view.s();
    };
    Label.prototype.an = function () {
        return this.view.e();
    };
    Label.prototype.provideContainer = function (a) {
        this.view.t(a);
    };
    Label.$t = markType(Label, 'Label', InputGroupItem.$);
    Label.c1 = BrushUtil.g(221, 0, 0, 0);
    Label.cy = BrushUtil.g(255, 0, 153, 155);
    Label.c0 = BrushUtil.g(221, 0, 0, 0);
    Label.cz = BrushUtil.g(255, 0, 153, 155);
    Label.cu = BrushUtil.g(255, 24, 29, 31);
    Label.cr = BrushUtil.g(255, 33, 150, 243);
    Label.ct = BrushUtil.g(255, 24, 29, 31);
    Label.cs = BrushUtil.g(255, 33, 150, 243);
    Label.k = 2;
    Label.c2 = ThemeResolver.e(Label.k, Label.c1, Label.cu);
    Label.cv = ThemeResolver.e(Label.k, Label.cy, Label.cr);
    Label.cx = ThemeResolver.e(Label.k, Label.c0, Label.ct);
    Label.cw = ThemeResolver.e(Label.k, Label.cz, Label.cs);
    Label.w = null;
    Label.ar = 0;
    return Label;
}(InputGroupItem));
export { Label };
/**
 * @hidden
 */
var Input = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input() {
        var _this = _super.call(this) || this;
        _this.v = null;
        _this.at = 0;
        _this.au = 0;
        _this.r = 0;
        _this.a9 = "";
        _this.a3 = "";
        _this.ab = false;
        _this.a4 = null;
        _this.ac = false;
        _this.ai = false;
        _this._view = null;
        _this.o = 0;
        _this.j = 1;
        _this.i = 1;
        _this.a8 = null;
        _this.bb = "_";
        _this.ae = false;
        _this.c3 = Input.c9;
        _this.c2 = Input.c8;
        _this.w = null;
        _this.c5 = Input.c9;
        _this.keyDown = null;
        _this.keyUp = null;
        _this.keyPress = null;
        _this.gotFocus = null;
        _this.lostFocus = null;
        _this.x = null;
        _this.a7 = "text";
        _this.ba = "text";
        _this.c4 = null;
        _this.a6 = "ig-input-" + Input.a1++;
        _this.av = 0;
        _this.ad = false;
        _this.a5 = null;
        _this.a2 = null;
        _this.ah = false;
        _this.bc = null;
        _this.ag = false;
        _this.af = false;
        _this.change = null;
        _this.changing = null;
        _this.compositionStart = null;
        _this.compositionEnd = null;
        _this.v = new MaskParsingService();
        var a = new InputView();
        a.a = _this;
        _this.view = a;
        _this.view.aj();
        Input.z = new FontInfo();
        Input.z.n = "'Segoe UI', Verdana";
        return _this;
    }
    Object.defineProperty(Input.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(Input.prototype, "p", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            var b = this.o;
            this.o = a;
            if (b != this.o) {
                this.g("ShiftType", enumGetBox(InputShiftType_$type, b), enumGetBox(InputShiftType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "l", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "k", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            var b = this.i;
            this.i = a;
            if (b != this.i) {
                this.g("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "bu", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (b != this.a8) {
                this.g("Mask", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "by", {
        get: function () {
            return this.bb;
        },
        set: function (a) {
            var b = this.bb;
            this.bb = a;
            if (b != this.bb) {
                this.g("PromptChar", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "al", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            var b = this.ae;
            this.ae = a;
            if (b != this.ae) {
                this.g("IncludeLiterals", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "TextColor":
            case "HoverTextColor":
            case "TextStyle":
                this.c0();
                break;
            case "ActualTextColor":
            case "ActualHoverTextColor":
            case "ActualTextStyle":
                this.cz();
                break;
            case "Value":
                if (!this.af) {
                    this.view.ao(this.b4);
                    if (this.b != null) {
                        this.b.mj();
                    }
                    if (this.bu != null && !this.ai) {
                        this.c1(this.b4);
                    }
                }
                break;
            case "Density":
                this.k = this.l == 0 ? 1 : this.l;
                break;
            case "ActualDensity":
                this.view.at();
                this.view.as();
                break;
            case "InputGroup":
                this.cj();
                break;
            case "ShiftType":
                this.cr();
                break;
            case "InputType":
                this.cs();
                break;
            case "Placeholder":
                this.cq();
                break;
            case "Mask":
                this.bw = this.bu;
                break;
            case "PromptChar": break;
            case "IncludeLiterals": break;
        }
    };
    Input.prototype.cq = function () {
        this.view.al();
    };
    Input.prototype.cs = function () {
        this.view.an();
    };
    Input.prototype.cr = function () {
        this.view.as();
    };
    Input.prototype.cj = function () {
        this.view.as();
    };
    Input.prototype.c0 = function () {
        this.c7 = this.db != null ? this.db : Input.c9;
        this.c6 = this.da != null ? this.da : Input.c9;
        this.y = this.aa != null ? this.aa : Input.z;
    };
    Input.prototype.cz = function () {
        if (this.y != null) {
            this.view.av(this.y);
        }
        NativeUI.n(this.view.n, this.c7);
    };
    Object.defineProperty(Input.prototype, "c7", {
        get: function () {
            return this.c3;
        },
        set: function (a) {
            var b = this.c3;
            this.c3 = a;
            if (b != this.c3) {
                this.g("ActualTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "c6", {
        get: function () {
            return this.c2;
        },
        set: function (a) {
            var b = this.c2;
            this.c2 = a;
            if (b != this.c2) {
                this.g("ActualHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "y", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (b != this.w) {
                this.g("ActualTextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "db", {
        get: function () {
            return this.c5;
        },
        set: function (a) {
            var b = this.c5;
            this.c5 = a;
            if (b != this.c5) {
                this.g("TextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.ca = function () {
        if (this.bu != null) {
            this.cx(this.b4);
        }
        if (null != this.lostFocus) {
            this.lostFocus(this, EventArgs.empty);
        }
    };
    Input.prototype.ci = function () {
        if (this.bu != null) {
            this.cy(this.b4);
        }
        if (null != this.gotFocus) {
            this.gotFocus(this, EventArgs.empty);
        }
    };
    Input.prototype.ck = function (a) {
        if (this.bu != null) {
            var b = a.keyCode;
            if ((b == 17 && b == 90) || (b == 17 && b == 89)) {
                a.preventDefault();
            }
            this.r = b;
            this.au = this.ax();
            this.at = this.aw();
        }
        if (null != this.keyDown) {
            this.keyDown(this, a);
        }
    };
    Input.prototype.cm = function (a) {
        if (null != this.keyUp) {
            this.keyUp(this, a);
        }
    };
    Input.prototype.cl = function (a) {
        if (null != this.keyPress) {
            this.keyPress(this, a);
        }
    };
    Input.prototype.cp = function () {
        if (this.bu != null) {
            this.a9 = this.b4;
            this.au = this.ax();
        }
    };
    Input.prototype.cg = function () {
        if (this.bu != null) {
            if (!this.ab) {
                this.cy(this.a3);
            }
        }
    };
    Input.prototype.ch = function () {
        if (this.bu != null) {
            if (!this.ab) {
                this.cx(this.b4);
            }
        }
    };
    Input.prototype.cb = function () {
        var _this = this;
        this.af = true;
        this.b4 = this.view.p();
        if (this.change != null) {
            this.change(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.b4;
                $ret.isCompositionInProgress = _this.view.d;
                return $ret;
            })()));
        }
        this.af = false;
    };
    Input.prototype.cc = function () {
        var _this = this;
        this.af = true;
        this.b4 = this.view.p();
        this.af = false;
        if (this.bu != null) {
            this.ai = true;
            if (this.ac) {
                this.au = this.ax();
            }
            if (this.b4.length < this.a9.length && this.r == 229) {
                this.r = 8;
            }
            var a = this.ax();
            var b = this.aw();
            var c = "";
            switch (this.r) {
                case 46:
                    this.at = this.au == this.at ? ++this.at : this.at;
                    break;
                case 8:
                    this.au = this.ax();
                    break;
                default:
                    c = this.b4.substr(this.au, this.aw() - this.au);
                    break;
            }
            var d = new MaskOptions();
            d.a = this.bu;
            d.b = this.by;
            var e = this.v.a(this.a9, c, d, this.au, this.at);
            this.b4 = e.b;
            if (this.r == 8) {
                e.a = this.au;
            }
            this.cw(e.a, e.a);
            var f = this.v.h(this.b4, d);
            this.a3 = this.al ? this.b4 : f;
            this.b6();
            this.ai = false;
        }
        this.af = true;
        if (this.changing != null) {
            this.changing(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.b4;
                $ret.isCompositionInProgress = _this.view.d;
                return $ret;
            })()));
        }
        this.af = false;
    };
    Input.prototype.ce = function () {
        if (this.compositionStart != null) {
            this.compositionStart(this, new EventArgs());
        }
    };
    Input.prototype.cd = function () {
        if (this.compositionEnd != null) {
            this.compositionEnd(this, new EventArgs());
        }
    };
    Input.prototype.cn = function () {
        this.an = true;
    };
    Input.prototype.co = function () {
        this.an = false;
    };
    Object.defineProperty(Input.prototype, "aa", {
        get: function () {
            return this.x;
        },
        set: function (a) {
            var b = this.x;
            this.x = a;
            if (b != this.x) {
                this.g("TextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "bq", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (b != this.a7) {
                this.g("InputType", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "bw", {
        get: function () {
            return this.ba;
        },
        set: function (a) {
            var b = this.ba;
            this.ba = a;
            if (b != this.ba) {
                this.g("Placeholder", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "da", {
        get: function () {
            return this.c4;
        },
        set: function (a) {
            var b = this.c4;
            this.c4 = a;
            if (b != this.c4) {
                this.g("HoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "bn", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (b != this.a6) {
                this.g("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "aj", {
        get: function () {
            return this.ad;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "a0", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            this.ad = true;
            if (b != this.av) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "bk", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            if (b != this.a5) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "bh", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (b != this.a2) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "an", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            var b = this.ah;
            this.ah = a;
            if (b != this.ah) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "b4", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            var b = this.bc;
            this.bc = a;
            if (b != this.bc) {
                this.g("Value", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "ak", {
        get: function () {
            return !stringIsNullOrEmpty(this.b4);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "disabled", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            var b = this.ag;
            this.ag = a;
            if (b != this.ag) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.ct = function () {
    };
    Input.prototype.onDetachedFromUI = function () {
        this.view.ah();
    };
    Input.prototype.onAttachedToUI = function () {
        this.view.af();
    };
    Input.prototype.ao = function () {
        return this.view.e();
    };
    Input.prototype.provideContainer = function (a) {
        this.view.ag(a);
    };
    Input.prototype.b8 = function () {
        this.ci();
        this.view.ai();
    };
    Input.prototype.cv = function () {
        this.view.am();
    };
    Input.prototype.cw = function (a, b) {
        this.view.aq(a, b);
    };
    Input.prototype.cy = function (a) {
        this.ai = true;
        var b = new MaskOptions();
        b.a = this.bu;
        b.b = this.by;
        this.b4 = this.v.g(this.b4, b);
        this.a9 = this.b4;
        this.ai = false;
    };
    Input.prototype.cx = function (a) {
        this.ai = true;
        var b = new MaskOptions();
        b.a = this.bu;
        b.b = this.by;
        if (a == this.v.g(null, b)) {
            this.b4 = "";
        }
        this.ai = false;
    };
    Input.prototype.c1 = function (a) {
        var _this = this;
        var b = new MaskOptions();
        b.a = this.bu;
        b.b = this.by;
        if (this.by != null && this.by.length > 1) {
            b.b = this.by.substr(0, 1);
        }
        this.b4 = a != null ? this.v.g(a, b) : "";
        this.a3 = this.al ? this.b4 : a;
        if (this.changing != null) {
            this.changing(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.b4;
                $ret.isCompositionInProgress = _this.view.d;
                return $ret;
            })()));
        }
    };
    Input.prototype.b6 = function () {
        this.a9 = this.b4;
        this.ac = false;
        this.au = 0;
        this.at = 0;
        this.r = 0;
    };
    Input.prototype.ax = function () {
        var a = this.view.m();
        var b = this.view.l();
        return a == b && this.ac ? b - this.a4.length : a;
    };
    Input.prototype.aw = function () {
        return this.view.l();
    };
    Object.defineProperty(Input.prototype, "selectionStart", {
        get: function () {
            return this.ax();
        },
        set: function (a) {
            this.view.ar(a);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "selectionEnd", {
        get: function () {
            return this.aw();
        },
        set: function (a) {
            this.view.ap(a);
        },
        enumerable: true,
        configurable: true
    });
    Input.$t = markType(Input, 'Input', InputGroupItem.$);
    Input.c9 = BrushUtil.g(221, 0, 0, 0);
    Input.c8 = BrushUtil.g(221, 0, 0, 0);
    Input.z = null;
    Input.a1 = 0;
    return Input;
}(InputGroupItem));
export { Input };
//# sourceMappingURL=InputGroupView_combined.js.map
